<template>
  <div class="bumpprevention-page">
    <div class="bumpprevention-top">
      <div class="bump-head">颠簸危害预防</div>
      <div class="bump-box">
        <div class="bump-ul">
          <div class="bump-left">
            <div class="bump-h">
              {{ flightDeailInfo ? flightDeailInfo.Departure : "-- --" }}
            </div>
            <div class="bump-p">
              {{ flightDeailInfo ? flightDeailInfo.etd_time : "-- --" }}
            </div>
          </div>
          <div class="bump-center">
            <div class="bump-number">
              {{ flightDeailInfo ? flightDeailInfo.FltNum : "-- --" }}
            </div>
            <div class="bump-li">
              <div class="bump-p">航程时间</div>
              <!-- 3h 23m -->
              <div class="bump-h">
                {{ flightDeailInfo ? flightDeailInfo.trip : "-- --" }}
              </div>
            </div>
            <div class="bump-li">
              <div class="bump-p">下降预警</div>
              <div class="bump-h">-- --</div>
            </div>
          </div>
          <div class="bump-right">
            <div class="bump-h">
              {{ flightDeailInfo ? flightDeailInfo.Destination : "-- --" }}
            </div>
            <div class="bump-p">
              {{ flightDeailInfo ? flightDeailInfo.land_time : "-- --" }}
            </div>
          </div>
        </div>
        <div class="bump-bt" @click="goHome">
          <img src="@/assets/images/index/icon.png" />首页
        </div>
      </div>
    </div>
    <div class="bumpprevention-box">
      <div class="bumpprevention-left">
        <!--告警展示-->
        <div class="alarmprompt-box">
          <div class="alarmprompt">
            <div class="alarmprompt-laber">飞行前告警</div>
            <div class="alarmprompt-img">
               <div class="alarmprompt-text" @click="checkWarningFlight(0)">
                <div class="alarmprompt-p">中度颠簸<span>{{foreWarning.moderate}}</span></div>
                <div class="alarmprompt-p active">重度颠簸<span>{{foreWarning.serious}}</span></div>
              </div>
              <img src="../../assets/images/index/r1.png"/>
              <img src="../../assets/images/index/r2.png"/>
            </div>
          </div>
          <div class="alarmprompt-line">/</div>
          <div class="alarmprompt">
            <div class="alarmprompt-laber">飞行中告警</div>
            <div class="alarmprompt-img">
              <div class="alarmprompt-text" @click="checkWarningFlight(1)">
                <div class="alarmprompt-p">中度颠簸<span>{{warning.moderate}}</span></div>
                <div class="alarmprompt-p active">重度颠簸<span>{{warning.serious}}</span></div>
              </div>
              <img src="../../assets/images/index/r1.png"/>
              <img src="../../assets/images/index/r2.png"/>
            </div>
          </div>
        </div>
        <!--左上角操作按钮-->
        <div class="operation-top">
          <div class="operation-ul">
            <div class="operation-li" @click="operateDistance(1)">
              <img src="@/assets/images/index/ic1.png" />
            </div>
            <div class="operation-li" @click="operateDistance(0)">
              <img src="@/assets/images/index/ic2.png" />
            </div>
          </div>
          <div class="operation-li" @click="setPortalPoint(true)">
            <img src="@/assets/images/index/ic3.png" />
          </div>
          <div class="operation-li" @click="setPortalPoint(false)">
            <img src="@/assets/images/index/ic4.png" />
          </div>
        </div>
        <!--左下角操作按钮-->
        <div class="operation-bottom">
          <div class="operation-a" @click="dialogVisible2 = true">
            <img src="@/assets/images/index/ic5.png" />
            <p>图例说明</p>
          </div>
          <div class="operation-a" @click="openFlightSearch">
            <img src="@/assets/images/index/ic6.png" />
            <p>航班</p>
          </div>
          <!-- <div class="operation-a" @click="openSetTime">
            <img src="@/assets/images/index/ic7.png" />
            <p>时间</p>
          </div> -->
          <div class="operation-a" @click="dialogVisible2 = true">
            <img src="@/assets/images/index/ic8.png" />
            <p>设置</p>
          </div>
        </div>
        <!--3D地球-->
        <div class="operation-img">
          <!--<img src="@/assets/images/index/diqiu.png"/>-->
          <div ref="chartContainer" class="chart-container"></div>
          <!--          <div class="stars" ref="starsRef">-->
          <!--            <div-->
          <!--              class="star"-->
          <!--              v-for="(item, index) in starsCount"-->
          <!--              :key="index"-->
          <!--            ></div>-->
          <!--          </div>-->
        </div>
        <!--右上角弹窗  old-->
        <!-- <div class="operation-modal">
          <div class="modal-li" v-if="foreWarningFlight.length > 0">
            <div class="modal-li-h">飞行前告警</div>
            <div class="modal-li-p">
              预计<span>{{ foreWarningFlight.length }}</span
              >个航班会遭遇颠簸
            </div>
            <div class="modal-li-a" @click="checkWarningFlight(0)">
              点击查看 >
            </div>
          </div>
          <div class="modal-li" v-if="WarningFlight.length > 0">
            <div class="modal-li-h">飞行中告警</div>
            <div class="modal-li-p">
              预计<span>{{ WarningFlight.length }}</span
              >个航班正在经历颠簸
            </div>
            <div class="modal-li-a" @click="checkWarningFlight(1)">
              点击查看 >
            </div>
          </div>
        </div> -->
        <!--底部标签栏-->
        <div class="label-box">
          <div class="label-ul">
            <div
              class="label-li"
              v-show="index < 4"
              v-for="(item, index) in labelList"
              :key="index"
              :class="item.active ? 'active' : ''"
            >
              <!--状态-->
              <img
                v-show="item.situation == 0"
                class="situation"
                src="@/assets/images/index/zt0.png"
              />
              <img
                v-show="item.situation == 1"
                class="situation"
                src="@/assets/images/index/zt1.png"
              />
              <img
                v-show="item.situation == 2"
                class="situation"
                src="@/assets/images/index/zt2.png"
              />
              <img
                v-show="item.situation == 3"
                class="situation"
                src="@/assets/images/index/zt3.png"
              />
              <img
                v-show="item.situation == 4"
                class="situation"
                src="@/assets/images/index/zt4.png"
              />
              <div class="label-li-left" @click="laberactive(index, item)">
                <p>{{ item.name }}</p>
                &nbsp;
                <p>{{ item.time }}</p>
              </div>
              <div class="label-li-right" @click="del(item)">
                <img src="@/assets/images/index/close.png" />
              </div>
            </div>
          </div>
          <div
            class="more"
            v-show="labelList.length > 4"
            @mouseover="mouseOver"
            @mouseleave="mouseLeave"
          >
            <span>···</span>
            <!--更多-->
            <div class="more-page">
              <div class="more-box" v-show="this.moreshow">
                <div class="more-head">打开的航班信息页</div>
                <div class="more-ul">
                  <div
                    class="label-li"
                    v-show="index >= 4"
                    v-for="(item, index) in labelList"
                    :class="item.active ? 'active' : ''"
                  >
                    <!--状态-->
                    <img
                      v-show="item.situation == 0"
                      class="situation"
                      src="@/assets/images/index/zt0.png"
                    />
                    <img
                      v-show="item.situation == 1"
                      class="situation"
                      src="@/assets/images/index/zt1.png"
                    />
                    <img
                      v-show="item.situation == 2"
                      class="situation"
                      src="@/assets/images/index/zt2.png"
                    />
                    <img
                      v-show="item.situation == 3"
                      class="situation"
                      src="@/assets/images/index/zt3.png"
                    />
                    <img
                      v-show="item.situation == 4"
                      class="situation"
                      src="@/assets/images/index/zt4.png"
                    />
                    <div
                      class="label-li-left"
                      @click="laberactive(index, item)"
                    >
                      <p>{{ item.name }}</p>
                      &nbsp;
                      <p>{{ item.time }}</p>
                    </div>
                    <div class="label-li-right" @click="del(item)">
                      <img src="@/assets/images/index/close.png" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bumpprevention-right">
        <div class="Airroute-null"></div>
        <div class="Airroute-head">
          <div class="head-left">航线</div>
          <div class="head-right">
            <!-- 雷雨天气 -->
            <div id="rainstorm">
              <!-- <div class="rainstorm-box">
                <img src="@/assets/images/index/laber1.png" />
              </div> -->
            </div>

            <div id="portal" style="display: flex">
              <!-- <div
                  class="head-line"
                  style="background: #EDD977;height: 12px;width: 20%;"
                ></div>
                <div
                  class="head-line"
                  style="background: #DC5357;height: 12px;width: 20%;"
                ></div> -->
            </div>
          </div>
        </div>
        <div class="Airroute-time">
          <div class="time-top" id="time—scale" style="position: relative">
            <!-- <div class="scale" v-for="(item, index) in 35"></div> -->
          </div>
          <div class="time-bottom" id="time-bottom">
            <!-- <div class="time">09:40</div>
              <div class="time">10:10</div>
              <div class="time">10:40</div>
              <div class="time">11:10</div>
              <div class="time">11:40</div>
              <div class="time">12:10</div> -->
          </div>
        </div>
        <div
          id="service_time"
          style="
            position: absolute;
            left: 60px;
            bottom: 24px;
            width: 550px;
            height: calc(100vh - 8.02vw);
          "
        >
          <!-- <div class="Deliverfood" style="width: 200px;left:calc(30% + 60px);">
              <img src="@/assets/images/index/laber2.png" />
            </div> -->
        </div>
        <div class="Airroute-ul">
          <!--灰框-->
          <!-- <div class="grey" style="width: 100px;left:calc(0% + 60px);"></div> -->
          <!--航班-->
          <div class="Airroute-li" v-for="(item, index) in flightLevelList">
            <div class="flight-left">{{ item }}</div>
            <div class="flight-ul" style="display: flex">
              <div style="flex: 1">
                <div
                  v-html="item"
                  v-for="(item, index) in bumpLevel[item]"
                ></div>
              </div>
              <!-- <div
                  class="flight-li"
                  style="background: #DC5357;height: 8px;width: 20%;"
                ></div> -->
            </div>
          </div>
        </div>
        <!-- 拖拽 @mousedown="startDrag"-->
        <div class="fj" style="height: 24px">
          <div
            class="fj-box"
            :style="{ left: left + 'px' }"
            @mousedown="startDrag"
            @touchstart="startDrag"
          >
            <img class="fjimg" src="@/assets/images/index/td.png" />
            <div class="fj-line"></div>
            <div class="fj-time">{{ Waypoint }}</div>
          </div>
        </div>
      </div>
    </div>
    <!--告警航班-->
    <div class="alarm-box">
      <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div class="modal-top">
          <div class="modal-head">{{warn_title[show_warn]}}</div>
          <div class="modal-close" @click="dialogVisible = false">
            <img src="@/assets/images/index/close.png" />
          </div>
        </div>
        <div class="alarm">
          <div class="alarm-tab">
            <div
              class="alarm-tab-li"
              :class="tabs == 3 ? 'active' : ''"
              @click="tabs = 3"
            >
              中度颠簸
            </div>
            <div
              class="alarm-tab-li"
              :class="tabs == 4 ? 'active' : ''"
              @click="tabs = 4"
            >
              重度颠簸
            </div>
          </div>
          <!-- 飞行前告警 -->
          <div class="alarm-ul" v-if="show_warn == 0">
            <div
              class="alarm-li"
              v-for="(item, index) in foreWarningFlight"
              v-if="item.bump==tabs"
              @click="readWarningFlightDetail(item)"
            >
              <div class="alarm-top">
                <div class="alarm-left">
                  <div class="alarm-date">
                    <div class="alarm-laber">航班号</div>
                    <div class="alarm-h"  :class="'bump' + item.bump">{{ item.name }}</div>
                  </div>
                </div>
                <div class="alarm-right">
                  <div class="alarm-date">
                    <div class="alarm-laber">机尾号</div>
                    <div class="alarm-P">{{ item.AircraftRegNum }}</div>
                  </div>
                  <div class="alarm-date">
                    <div class="alarm-laber">机型</div>
                    <div class="alarm-P">{{ item.AircraftType }}</div>
                  </div>
                </div>
              </div>
              <div class="alarm-bottom">
                <div class="alarm-left">
                  <div class="alarm-date">
                    <div class="alarm-laber">
                      计划时间<span>{{ item.trip }}</span>
                    </div>
                    <div class="alarm-time">
                      <div class="time-li">
                        <img src="@/assets/images/index/up.png" />
                        <span>{{ item.Departure }}</span>
                        <span>{{ item.etd_time_hs }}</span>
                      </div>
                      <div class="time-li">
                        <img src="@/assets/images/index/up2.png" />
                        <span>{{ item.Destination }}</span>
                        <span>{{ item.land_time_hs }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="alarms">预计遭遇颠簸</div>
              </div>
            </div>
          </div>

          <!-- 飞行中告警 -->
          <div class="alarm-ul" v-if="show_warn == 1">
            <div
              class="alarm-li"
              v-for="(item, index) in WarningFlight"
              v-if="item.bump==tabs"
              @click="readWarningFlightDetail(item)"
            >
              <div class="alarm-top">
                <div class="alarm-left">
                  <div class="alarm-date">
                    <div class="alarm-laber">航班号</div>
                    <div class="alarm-h" :class="'bump' + item.bump">{{ item.name }}</div>
                  </div>
                </div>
                <div class="alarm-right">
                  <div class="alarm-date">
                    <div class="alarm-laber">机尾号</div>
                    <div class="alarm-P">{{ item.AircraftRegNum }}</div>
                  </div>
                  <div class="alarm-date">
                    <div class="alarm-laber">机型</div>
                    <div class="alarm-P">{{ item.AircraftType }}</div>
                  </div>
                </div>
              </div>
              <div class="alarm-bottom">
                <div class="alarm-left">
                  <div class="alarm-date">
                    <div class="alarm-laber">
                      计划时间<span>{{ item.trip }}</span>
                    </div>
                    <div class="alarm-time">
                      <div class="time-li">
                        <img src="@/assets/images/index/up.png" />
                        <span>{{ item.Departure }}</span>
                        <span>{{ item.etd_time_hs }}</span>
                      </div>
                      <div class="time-li">
                        <img src="@/assets/images/index/up2.png" />
                        <span>{{ item.Destination }}</span>
                        <span>{{ item.land_time_hs }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="alarms">正在经历或即将遭遇颠簸</div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!--设置-->
    <div class="alarm-box">
      <el-dialog :visible.sync="dialogVisible2">
        <div class="modal-top">
          <div class="modal-head">设置</div>
          <div class="modal-close" @click="dialogVisible2 = false">
            <img src="@/assets/images/index/close.png" />
          </div>
        </div>
        <div class="set-box">
          <div class="set-li">
            <div class="set-laber">
              <img src="@/assets/images/index/set1.png" />
              图例说明
            </div>
            <div class="legend-ul">
              <div class="legend-li">
                <img src="@/assets/images/index/set2.png" />
                <span>轻度颠簸</span>
              </div>
              <div class="legend-li">
                <img src="@/assets/images/index/set3.png" />
                <span>轻中度颠簸</span>
              </div>
              <div class="legend-li">
                <img src="@/assets/images/index/set4.png" />
                <span>中度颠簸</span>
              </div>
              <div class="legend-li">
                <img src="@/assets/images/index/set5.png" />
                <span>重度颠簸</span>
              </div>
              <div class="legend-li">
                <img src="@/assets/images/index/set6.png" />
                <span>密集雷雨</span>
              </div>
              <div class="legend-li">
                <img src="@/assets/images/index/set7.png" />
                <span>松散雷雨</span>
              </div>
              <div class="legend-li">
                <img src="@/assets/images/index/set8.png" />
                <span>客舱服务</span>
              </div>
            </div>
          </div>
          <div
            class="set-li"
            style="cursor: pointer"
            @click="dialogVisible8 = true"
          >
            <div class="set-laber">
              <img src="@/assets/images/index/set1.png" />
              颠簸情况
            </div>
            <div class="situation-h">轻度颠簸</div>
            <div class="situation-line">
              <div class="situation" style="left: 20%"></div>
            </div>
            <div class="situation-p">当前天气情况为：轻度雷雨</div>
          </div>
<!--          <div class="set-li active" @click="dialogVisible4 = true">
            <div class="feedback-box">
              <img src="@/assets/images/index/set9.png" />
              <div class="feedback-text">
                <div class="feedback-h">意见反馈</div>
                <div class="feedback-p">
                  您可以描述所遇到的问题反馈给我们，协助我们改进系统功能。
                </div>
              </div>
            </div>
            <img src="@/assets/images/index/set10.png" />
          </div>-->
          <div class="set-li active2">
            <div class="translation-li" @click="dialogVisible6 = true">
              <div class="translation-left">
                <img src="@/assets/images/index/set11.png" />
                <span>语言设置</span>
              </div>
              <img src="@/assets/images/index/set10.png" />
            </div>
            <div class="translation-li" @click="dialogVisible7 = true">
              <div class="translation-left">
                <img src="@/assets/images/index/set12.png" />
                <span>关于我们</span>
              </div>
              <img src="@/assets/images/index/set10.png" />
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!--我的航班-->
    <div class="alarm-box">
      <el-dialog
        :visible.sync="dialogVisible3"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div class="modal-top active">
          <div class="modal-head">我的航班</div>
          <div class="modal-close" @click="dialogVisible3 = false">
            <img src="@/assets/images/index/close.png" />
          </div>
        </div>
        <div class="search">
          <img src="@/assets/images/index/ss.png" />
          <input
            placeholder="搜索航班"
            v-model="sear_flight"
            @keyup.enter="searchFlight"
          />
        </div>
        <div
          class="alarm active" style="height: 80vh;"
          v-loading="loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          element-loading-text="航班列表加载中"
        >
          <div class="alarm-ul" v-infinite-scroll="load" infinite-scroll-immediate="false" infinite-scroll-distance="1" >
            <div
              class="alarm-li"
              v-for="(item, index) in flightLists"
              @click="queryFlightDetail(item)"
              style="cursor: pointer"
            >
              <div class="alarm-top">
                <div class="alarm-left">
                  <div class="alarm-date">
                    <div class="alarm-laber">航班号</div>
                    <div
                      class="alarm-h"
                      :class="'bump' + item.bump_high_status"
                      v-if="item.bump_high_status > 1"
                    >
                      {{ item.flgtno }}
                    </div>
                    <div class="alarm-h" v-if="item.bump_high_status < 2">
                      {{ item.flgtno }}
                    </div>
                  </div>
                </div>
                <div class="alarm-right">
                  <div class="alarm-date">
                    <div class="alarm-laber">机尾号</div>
                    <div class="alarm-p">{{ item.aircraft }}</div>
                  </div>
                  <div class="alarm-date">
                    <div class="alarm-laber">机型</div>
                    <div class="alarm-p">{{ item.acftmodl }}</div>
                  </div>
                </div>
              </div>
              <div class="alarm-bottom">
                <div class="alarm-left">
                  <div class="alarm-date">
                    <div class="alarm-laber">
                      计划时间<span>{{ item.triptime }}</span>
                    </div>
                    <div class="alarm-time active">
                      <div class="time-li">
                        <img src="@/assets/images/index/up3.png" />
                        <span>{{ item.tkofarpt }}</span>
                        <span class="alarm-pp">{{ item.lanchTimeFormat }}</span>
                      </div>
                      <div class="time-li">
                        <img src="@/assets/images/index/up4.png" />
                        <span>{{ item.arvlarpt }}</span>
                        <span class="alarm-pp">{{ item.fallTimeFormat }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ecahrts-li">
                  <EChart  :severe="item.severe_bump" :moderate="item.moderate_bump" chartWidth="100%" chartHeight="100px"/>
                </div>
              </div>
            </div>
            <!-- 分页 -->
<!--            <div style="text-align: center">-->
<!--              <el-pagination-->
<!--                v-show="listQuery.total > 0"-->
<!--                background-->
<!--                layout="prev, pager, next"-->
<!--                :page.sync="listQuery.page"-->
<!--                :limit.sync="listQuery.list_rows"-->
<!--                :total="listQuery.total"-->
<!--                @pagination="searchFlight"-->
<!--                @current-change="handleCurrentChange"-->
<!--              >-->
<!--              </el-pagination>-->
<!--            </div>-->
            <!-- <div class="alarm-li active">
                <div class="alarm-top">
                  <div class="alarm-left">
                    <div class="alarm-date">
                      <div class="alarm-laber">航班号</div>
                      <div class="alarm-h active">CSN385423</div>
                    </div>
                  </div>
                  <div class="alarm-right">
                    <div class="alarm-date">
                      <div class="alarm-laber">机尾号</div>
                      <div class="alarm-p">B1089</div>
                    </div>
                    <div class="alarm-date">
                      <div class="alarm-laber">机型</div>
                      <div class="alarm-p">A321-271</div>
                    </div>
                  </div>
                </div>
                <div class="alarm-bottom">
                  <div class="alarm-left">
                    <div class="alarm-date">
                      <div class="alarm-laber">计划时间<span>3H30m</span></div>
                      <div class="alarm-time">
                        <div class="time-li">
                          <img src="@/assets/images/index/up5.png" />
                          <span>ZGGG</span>
                          <span class="">09:00</span>
                        </div>
                        <div class="time-li">
                          <img src="@/assets/images/index/up6.png" />
                          <span>ZSNJ</span>
                          <span class="">19:00</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->

            <!-- <div class="alarm-li active active2">
                <div class="alarm-top">
                  <div class="alarm-left">
                    <div class="alarm-date">
                      <div class="alarm-laber">航班号</div>
                      <div class="alarm-h active">CSN385423</div>
                    </div>
                  </div>
                  <div class="alarm-right">
                    <div class="alarm-date">
                      <div class="alarm-laber">机尾号</div>
                      <div class="alarm-p">B1089</div>
                    </div>
                    <div class="alarm-date">
                      <div class="alarm-laber">机型</div>
                      <div class="alarm-p">A321-271</div>
                    </div>
                  </div>
                </div>
                <div class="alarm-bottom">
                  <div class="alarm-left">
                    <div class="alarm-date">
                      <div class="alarm-laber">计划时间<span>3H30m</span></div>
                      <div class="alarm-time">
                        <div class="time-li">
                          <img src="@/assets/images/index/up5.png" />
                          <span>ZGGG</span>
                          <span class="">09:00</span>
                        </div>
                        <div class="time-li">
                          <img src="@/assets/images/index/up6.png" />
                          <span>ZSNJ</span>
                          <span class="">19:00</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
          </div>
        </div>
      </el-dialog>
    </div>
    <!--意见反馈-->
    <div class="interaction">
      <el-dialog :visible.sync="dialogVisible4">
        <div class="interaction-head">意见反馈</div>
        <img
          src="@/assets/images/index/close.png"
          class="modalclose"
          @click="dialogVisible4 = false"
        />
        <div class="interaction-box">
          <div class="interaction-li">
            <div class="interaction-left active">选择问题类型：</div>
            <div class="interaction-right">
              <el-select v-model="feedback" placeholder="请选择">
                <el-option
                  v-for="item in feedbackOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="interaction-li">
            <div class="interaction-left">详细内容：</div>
            <div class="interaction-right">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="textarea"
              >
              </el-input>
            </div>
          </div>
        </div>
        <div class="bt-box">
          <div class="interaction-bt">提交反馈</div>
        </div>
      </el-dialog>
    </div>
    <!--时间-->
    <div class="interaction ac1">
      <el-dialog :visible.sync="dialogVisible5">
        <div class="interaction-head">时间</div>
        <img
          src="@/assets/images/index/close.png"
          class="modalclose"
          @click="dialogVisible5 = false"
        />
        <div class="interaction-box">
          <div class="interaction-li">
            <div class="interaction-left active">时区选择：</div>
            <div class="interaction-right">
              <el-select v-model="timeZone" placeholder="请选择">
                <el-option
                  v-for="item in time_zone"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="interaction-li">
            <div class="interaction-left active">起飞时间：</div>
            <div class="interaction-right">
              <!-- <el-input placeholder="请输入起飞时间" v-model="actual_etd_time">
              </el-input> -->
              <el-date-picker
                v-model="actual_etd_time"
                placeholder="请输入起飞时间"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:00"
              ></el-date-picker>
              <!-- <div class="hq">获取当前时间</div> -->
            </div>
          </div>
        </div>
        <div class="bt-box">
          <div class="interaction-bt active" @click="setActualEtdTime">
            确认
          </div>
          <div class="interaction-bt">重新选择航班</div>
        </div>
      </el-dialog>
    </div>
    <!--語言設置-->
    <div class="interaction ac1">
      <el-dialog :visible.sync="dialogVisible6">
        <div class="interaction-head">语言设置</div>
        <img
          src="@/assets/images/index/close.png"
          class="modalclose"
          @click="dialogVisible6 = false"
        />
        <div class="interaction-box">
          <div class="interaction-li">
            <div class="interaction-right">
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="bt-box">
          <div class="interaction-bt active">确认</div>
        </div>
      </el-dialog>
    </div>
    <!--关于我们-->
    <div class="interaction ac2">
      <el-dialog :visible.sync="dialogVisible7">
        <img
          src="@/assets/images/index/close.png"
          class="modalclose"
          @click="dialogVisible7 = false"
        />
        <div class="aboutus-box">
          <img src="@/assets/images/logo.png" />
          <div class="aboutus-h">运行危险源及特情处置系统</div>
          <div class="aboutus-p">V1.7.8</div>
        </div>
        <div class="aboutus-laber">运行危险源及特情处置系统</div>
      </el-dialog>
    </div>
    <!--颠簸简报-->
    <div class="interaction acc2">
      <el-dialog :visible.sync="dialogVisible8">
        <div class="interaction-head">颠簸简报</div>
        <img
          src="@/assets/images/index/close.png"
          class="modalclose"
          @click="dialogVisible8 = false"
        />
        <div class="briefnote-box">
          <div class="briefnote-top">
            <div class="briefnote-li">
              <div class="briefnote-h">CSN6903</div>
              <div class="briefnote-p">进入剩余时间</div>
            </div>
            <div class="briefnote-li">
              <div class="briefnote-h">10:33-10:41</div>
              <div class="briefnote-p">时间段</div>
            </div>
            <div class="briefnote-li">
              <div class="briefnote-h active">LT-MOD</div>
              <div class="briefnote-p">飞行状态</div>
            </div>
            <div class="briefnote-li">
              <div class="briefnote-h">2小时26分</div>
              <div class="briefnote-p">进入剩余时间</div>
            </div>
          </div>
          <div class="briefnote-bottom">
            <div class="briefnote-head">安全措施：</div>
            <div class="briefnote-text">
              <div class="briefnote-p">
                1.飞行员技术熟练程度是保证飞行安全的主要因素。飞行技术一般与飞行时间、经验成正比。
              </div>
              <div class="briefnote-p">
                1.飞行员技术熟练程度是保证飞行安全的主要因素。飞行技术一般与飞行时间、经验成正比。
              </div>
              <div class="briefnote-p">
                1.飞行员技术熟练程度是保证飞行安全的主要因素。飞行技术一般与飞行时间、经验成正比。
              </div>
              <div class="briefnote-p">
                1.飞行员技术熟练程度是保证飞行安全的主要因素。飞行技术一般与飞行时间、经验成正比。
              </div>
              <div class="briefnote-p">
                1.飞行员技术熟练程度是保证飞行安全的主要因素。飞行技术一般与飞行时间、经验成正比。
              </div>
              <div class="briefnote-p">
                1.飞行员技术熟练程度是保证飞行安全的主要因素。飞行技术一般与飞行时间、经验成正比。
              </div>
              <div class="briefnote-p">
                1.飞行员技术熟练程度是保证飞行安全的主要因素。飞行技术一般与飞行时间、经验成正比。
              </div>
              <div class="briefnote-p">
                1.飞行员技术熟练程度是保证飞行安全的主要因素。飞行技术一般与飞行时间、经验成正比。
              </div>
              <div class="briefnote-p">
                1.飞行员技术熟练程度是保证飞行安全的主要因素。飞行技术一般与飞行时间、经验成正比。
              </div>
              <div class="briefnote-p">
                1.飞行员技术熟练程度是保证飞行安全的主要因素。飞行技术一般与飞行时间、经验成正比。
              </div>
            </div>
          </div>
        </div>
        <div class="bt-box active">
          <div class="interaction-bt active">确认</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import WorldJson from "../../assets/countries.geo.json";
import { pageFltPlan } from "@/api/api";
import { flightDetail,flightBump } from "@/api/bump";
import siteNavVue from "../../components/base/siteNav.vue";
import EChart from './echarts';

export default {
  name: "index",
  components: {
    EChart,
  },
  data() {
    return {
      chart: null,

      starsCount: 800, //星星数量
      distance: 600, //间距
      dialogVisible: false, //告警航班弹窗
      dialogVisible2: false, //设置弹窗
      dialogVisible3: false, //我的航班
      dialogVisible4: false, //意见反馈
      dialogVisible5: false, //时间
      dialogVisible6: false, //语言
      dialogVisible7: false, //关于我们
      dialogVisible8: false, //颠簸简报
      textarea: "",
      tabs: 3, //告警航班tab切换
      show_warn:0,//告警航班弹框
      warn_title:{0:'飞行前告警航班',1:'飞行中告警航班'},
      isDragging: false, // 是否正在拖拽
      startX: 0, // 鼠标点击时的初始X坐标
      startY: 0, // 鼠标点击时的初始Y坐标
      left: 40, // 拖拽元素的左边距
      top: 0, // 拖拽元素的上边距
      moreshow: false,
      options: [
        {
          value: "0",
          label: "中文",
        },

      ],
      feedbackOptions:[
        {
          value: "0",
          label: "反馈1",
        },
        {
          value: "1",
          label: "反馈2",
        },
      ],
      value: "0",
      feedback:"1",
      Waypoint: "00:00",
      labelList: [],
      sear_flight: "CSN", //搜索航班
      flightLists: [], //航班列表
      flightDeailInfo: [], //航班详情
      pointtList: [], //航班的经纬点坐标集合
      //航线经纬点集合
      portalLinePoint: [],
      flightLevelList: [
        "FL400",
        "FL390",
        "FL380",
        "FL370",
        "FL360",
        "FL350",
        "FL340",
        "FL330",
        "FL320",
        "FL310",
        "FL300",
        "FL290",
        "FL280",
        "FL270",
        "FL260",
        "FL250",
        "FL240",
        "FL230",
        "FL220",
        "FL210",
        "FL200",
        "FL190",
        "FL180",
        "FL170",
        "FL160",
        "FL150",
        "FL140",
        "FL130",
        "FL120",
        "FL110",
        "FL100",
      ], //高度层集合

      //不同颠簸等级的色值"#86D579", "#E9CF4F", "#DEA15F", "#DC5357"
      bumoColor: ["", "#86D579", "#EDD977", "#DEA15F", "#DC5357"],

      bumpLevel: [],
      point_index: 0, //当前航路点的下标
      timePointList: [], //时刻航路点对应信息
      timePercentList: [], //各国航路时刻在时刻线上所占的百分比
      timeBumpList: [], //不同航路时刻下的颠簸程度+
      //分页参数
      listQuery: {
        page: 1,
        list_rows: 10,
        total: 0,
      },
      loading: false,
      //定时任务，判断搜索的历史航班中各个航班当前时刻的颠簸状况
      timer: null,
      foreWarningFlight: [], //飞行前告警航班
      WarningFlight: [], //飞行中或者即将遭遇颠簸的航班
      earth_distance: 250, //地球缩放距离，值越小，地球越大
      targetCoord: [116, 39], //3d地球上定位的目标位置坐标
      time_zone: [
        {
          value: "0",
          label: "UTC",
        },
      ], //时区选项
      timeZone: "0",
      actual_etd_time: "",
      foreWarning:{moderate:0,serious:0},
      warning:{moderate:0,serious:0},
    };
  },
  mounted() {
    // this.flightLevelList.reverse()
    //从storage获取搜索历史的集合
    var history = this.$storage.get("flightHistory");
    console.log(history, "搜索历史");
    //从storage获取搜素词和缓存值
    // var flight = this.$storage.get("sear_flight");
    //从storage中获取缓存的航班列表
    var flight_list = this.$storage.get("flightLists");
    //从缓存获取航班详情信息
    var flight_detail = this.$storage.get("flightDetail");
    this.flightDeailInfo = flight_detail;
    console.log("缓存航班信息", flight_detail);
    this.clearInfo();
    if (flight_detail) {
      //处理航路点位信息
      this.hanleFlightRoute(flight_detail.RouteInformation);
      this.countPortalBump(
        flight_detail.RouteInformation,
        flight_detail.TripTime
      );
      this.countLevelBump(
        flight_detail.RouteInformation,
        flight_detail.TripTime
      );
      this.countTimeList(
        flight_detail.RouteInformation,
        flight_detail.TripTime
      );
      this.counrFoodService(flight_detail.syncData, flight_detail.TripTime);
      //计算雷电气象
      this.countRainStorm(
        flight_detail.RouteInformation,
        flight_detail.TripTime
      );
    }
    if (history) {
      this.labelList = history;
      this.startHistoryBumpCount();
    }

    // this.flightLists = flight_list;
    // this.sear_flight = flight;

    this.$nextTick(() => {
      this.getBaseTexture();// 初始化图表
    });
    // let starNodes = Array.from(this.$refs.starsRef.children);
    // starNodes.forEach(item => {
    //   let speed = 0.2 + Math.random() * 1;
    //   let thisDistance = this.distance + Math.random() * 300;
    //   item.style.transformOrigin = `0 0 ${thisDistance}px`;
    //   item.style.transform = `
    //       translate3d(0,0,-${thisDistance}px)
    //       rotateY(${Math.random() * 360}deg)
    //       rotateX(${Math.random() * -50}deg)
    //       scale(${speed},${speed})`;
    // });
    window.addEventListener('resize', this.resizeChart); // 添加resize事件监听
  },
   beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart); // 在组件销毁前移除resize事件监听
    if (this.chart) { // 销毁图表实例释放内存
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    load () {
      console.log('__________________________________________________________________________________________')
      this.listQuery.page++
      this.searchFlight()
    },
    //查看告警航班
    checkWarningFlight(type) {
      this.dialogVisible = true;
      this.show_warn = type;
    },
    openFlightSearch() {
      this.flightLists=[]
      this.listQuery.page=1
      this.dialogVisible3 = true;
      this.searchFlight();
    },
    goHome() {
      this.$router.push("/index");
    },
    handleCurrentChange(val) {
      this.loading = true;
      this.listQuery.page = val;
      this.searchFlight();
      // console.log(`当前页: ${val}`);
    },
    //搜索航班列表
    async searchFlight() {
      if (!this.sear_flight) {
        this.$message({
          type: "warning",
          message: "航班号不能为空",
        });
        return false;
      }

      //判断搜索关键词是否一致，不一致就要清空航班列表重新获取列表数据，因为是下划加载数据，数据是追加上去的
      var flight = this.$storage.get("sear_flight");
      if(flight!=this.sear_flight){
       console.log('前后搜索词不一致')
        //前后搜索词不一致
        this.flightLists=[]
        this.listQuery.page=1
      }else{
         console.log('前后搜索词一致')
      }
      //接口请求航班列表

      //把搜索词放入到缓存中
      this.$storage.set("sear_flight", this.sear_flight); //创建 OR修改,并在创建时给一个过期时间限制
      this.loading = true;
      const param = {};
      param.fltNum = this.sear_flight;
      const result = await pageFltPlan(
        this.listQuery.page,
        this.listQuery.list_rows,
        param
      );
      if (result.code === "A00000") {
        var flight_list = result.data;
        if(flight_list.length<=0){
          this.loading = false;
          // this.$message.warning('暂无更多航班数据');
          return false;
        }
        //字段处理
        // this.flightLists.forEach((item, index) => {
        //   item.triptime = this.common.ForamtTime(item.triptime, 2);
        //   console.log(this.eachFlightBumpStatus(item),44444455555)
        //   item.bump_high_status = this.eachFlightBumpStatus(item);

        // });
        let promises = flight_list.map(async (item) => {
          item.triptime = this.common.ForamtTime(item.triptime, 2);
          item.bump_high_status = await this.eachFlightBumpStatus(item);
        });

        for (const promise of promises) {
          await promise;
        }
        flight_list=await this.getFlightBumpStatus(flight_list)
        this.flightLists = [...this.flightLists, ...flight_list]
        this.listQuery.total = result.totalCount;
        this.loading = false;
        // console.log(this.flightLists, "884984894944999");
        // this.$storage.set("flightLists", this.flightLists, 7200000);
      } else {
        this.loading = false;
        this.$message.error(result.message);
        return false;
      }

      console.log(this.flightLists,'4564654654654fv65d4gvdgv')
    },


    //获取每个航班近几天的颠簸统计情况
    async getFlightBumpStatus(flight_list){

      //获取航班航班号集合
      var flight=[]
      flight_list.forEach((item)=>{
          flight.push(item.flgtno)
      })


         //获取过去7天的日期集合
        var dateList=this.common.getDateList(new Date())

        // return false;
        const param={}
        param.fltNums=flight
        param.startDay=dateList[0]
        param.endDay=dateList[dateList.length-1]
        const result = await flightBump(param);
        var flight_bump=[]
        if(result.code=== "A00000"){
          // console.log(result.data,'457575758njhnihiohoi')
          if(result.data.length>0){
            var list=result.data
            //遍历各个航班的颠簸统计
            list.forEach((item,index)=>{
              //遍历不同日期的颠簸数据
              var severe_bump  =[]//重度颠簸集合
              var moderate_bump=[]//中度颠簸集合
              if(item.bumpList.length>0){
                  item.bumpList.forEach((val,key)=>{
                    severe_bump.push(val.severeTime)
                    moderate_bump.push(val.moderateTime)
                  })
              }
              flight_bump[item.fltNum]={}
              flight_bump[item.fltNum].severe_bump=severe_bump
              flight_bump[item.fltNum].moderate_bump=moderate_bump
            })
          }
        }

        //
    flight_list.forEach((item)=>{
      if(flight_bump[item.flgtno]){
        var bump_info=flight_bump[item.flgtno]
          item.severe_bump=bump_info.severe_bump
          item.moderate_bump=bump_info.moderate_bump
      }else{

          item.severe_bump=[0,0,0,0,0,0,0]
          item.moderate_bump=[0,0,0,0,0,0,0]
      }

      })
      return flight_list

    },


    //查询的航班列表遍历获取其详情，
    // 并根据对应的详情判断所在航程的最高等级的颠簸，
    // 把红橙两种等级的颠簸颜色标识在列表中的航班号上
    async eachFlightBumpStatus(info) {
      //获取航班详情
      const param = {};
      param.FltNum = info.flgtno;
      param.ETD = info.flgtetd;
      // param.id=flight.id
      const result = await flightDetail(param);
      var bump_status = 0;
      var bump_list = [];
      if (result.code === "A00000") {
        var list = result.data;
        if (list[0]) {
          var routrInfo = list[0]["RouteInformation"];
          routrInfo.forEach((item, index) => {
            var fl_status = 0;
            if (Number(item.FlightLevel)) {
              //当飞机的飞行高度拥有确切数值
              var index = this.common.findCloseNum(Number(item.FlightLevel)); //下标
              var fl_index = "FL" + index;
            } else {
              //当飞机处于爬升或者下降过程中并没有一个确切的数值，默认取第一个高度点的颠簸值
              var fl_index = "FL050";
            }

            fl_status = Number(item[fl_index]); //对应的高度颠簸值
            bump_list.push(fl_status);
          });

          // console.log(bump_list,'4654564;5484984]]]]]')
          if (bump_list.indexOf(4) > -1) {
            bump_status = 4;
          } else if (bump_list.indexOf(3) > -1) {
            bump_status = 3;
          } else if (bump_list.indexOf(2) > -1) {
            bump_status = 2;
          } else {
            bump_status = 0;
          }
        }
      }

      return bump_status;
    },

    clearInfo() {
      this.sear_flight = "CSN";
      this.left = 40;
      this.Waypoint = "00:00" + (this.flightDeailInfo&&this.flightDeailInfo.Departure||'');
      this.bumpLevel = [];
    },

    //获取航班详情
    async queryFlightDetail(flight, is_history = false) {
      const param = {};
      param.FltNum = flight.flgtno;
      param.ETD = flight.flgtetd;
      // param.id=flight.id
      const result = await flightDetail(param);

      if (result.code === "A00000") {
        const list = result.data;

        if (list[0]) {
          this.flightDeailInfo = list[0];
          this.flightDeailInfo.actual_etd_time = flight.actual_etd_time
            ? flight.actual_etd_time
            : "";
          var label = list[0];
          this.clearInfo();
          this.handleFlighrDetail(is_history);
          this.dialogVisible3 = false;
        } else {
          this.$message.error("未能获取到有效航班信息,请重试!");
          return false;
        }
      } else {
        this.$message.error(result.message);
        return false;
      }
    },

    //航班详情处理
    handleFlighrDetail(is_history = false) {
      //航程时间格式转换
      this.flightDeailInfo.trip = this.common.ForamtTime(
        this.flightDeailInfo.TripTime,
        1
      );
      //根据起飞时间和航程时间计算计划落地时间
      //落地时间转换为时间戳
      if (this.flightDeailInfo.actual_etd_time) {
        var etd_time_stamp = new Date(
          this.flightDeailInfo.actual_etd_time
        ).getTime();
      } else {
        var etd_time_stamp = new Date(this.flightDeailInfo.ETD).getTime();
      }

      //转换时区
      var time_zone = this.common.getTimeZone();
      etd_time_stamp += time_zone * 3600 * 1000;
      //落地时间戳
      var land_time_stamp =
        etd_time_stamp +
        this.common.time_to_sec(this.flightDeailInfo.TripTime) * 1000;

      var land_time = this.common.FormTimeStamp(land_time_stamp);
      this.flightDeailInfo.land_time = land_time;
      this.flightDeailInfo.etd_time = this.common.FormTimeStamp(etd_time_stamp);
      console.log("航班详情", this.flightDeailInfo);

      //当有结果返回时，把查询结果房间底部的label中
      const label = this.flightDeailInfo;
      if (!is_history) {
        //最多10个搜索航班，超过10删除第一个
        if (this.labelList.length >= 10) {
          this.labelList.splice(this.labelList.length - 1, 1);
        }
        this.labelList.forEach((val, key) => {
          val.active = false;
        });

        label.active = true;
        label.situation = 0;
        label.name = this.flightDeailInfo.FltNum;
        label.time = this.common.FormTimeStamp(etd_time_stamp);
        label.etd_time_hs = this.common.FormTimeStamp(etd_time_stamp, 2);
        if (this.flightDeailInfo.actual_etd_time) {
          label.etd = this.flightDeailInfo.actual_etd_time;
        } else {
          label.etd = this.flightDeailInfo.ETD;
        }

        label.land_time = this.common.FormTimeStamp(land_time_stamp, 3);
        label.land_time_hs = this.common.FormTimeStamp(land_time_stamp, 2);
        label.etd_time = this.common.FormTimeStamp(etd_time_stamp, 3);
        // label.triptime = this.common.ForamtTime(label.TripTime, 2);
        this.labelList.unshift(label);
        //把结果存进缓存中设置缓存有效期
        this.$storage.set("flightHistory", this.labelList);
      }

      //经纬点位集合
      this.hanleFlightRoute(this.flightDeailInfo.RouteInformation);
      //航线点位颠簸情况
      this.countPortalBump(
        this.flightDeailInfo.RouteInformation,
        this.flightDeailInfo.TripTime
      );
      //计算各个航路点不同高度层的颠簸值
      this.countLevelBump(
        this.flightDeailInfo.RouteInformation,
        this.flightDeailInfo.TripTime
      );
      this.countTimeList(
        this.flightDeailInfo.RouteInformation,
        this.flightDeailInfo.TripTime
      );
      this.counrFoodService(
        this.flightDeailInfo.syncData,
        this.flightDeailInfo.TripTime
      );

      this.countRainStorm(
        this.flightDeailInfo.RouteInformation,
        this.flightDeailInfo.TripTime
      );

       this.intervalContainer();
      this.$storage.set("flightDetail", this.flightDeailInfo);
    },

    //计算餐食服务时间
    counrFoodService(data, trip) {
      console.log(data, "餐食服务");
      var service = [];
      var service_html = "";
      data.forEach((item, index) => {
        if (item.backup_bata) {
          var info = JSON.parse(item.backup_bata);
          info.forEach((val, key) => {
            service.push(val);
          });
        }
      });

      //计算平均占比
      var total_time = this.common.time_to_sec(trip);
      //面对百分百的航程，平均每一秒的百分比
      var average_percent = 100 / total_time;

      // <div class="Deliverfood" style="width: 200px;left:calc(30% + 60px);">
      //   <img src="@/assets/images/index/laber2.png" />
      // </div>;
      if (service && service.length > 0) {
        service.forEach((item, index) => {
          //计算餐食区域的宽度和左边距
          var start_time = this.common.time_to_sec(item.servicebegintime);
          var end_time = this.common.time_to_sec(item.servicefinishtime);
          //服务的时间区域
          var service_time = parseInt(end_time - start_time) * average_percent;
          var service_start_time = start_time * average_percent;
          service_html +=
            `<div class='Deliverfood' style='height:100%;border-color: #907acc;bottom: 0px;border-style: solid;border-width: 0px 1px;background: rgba(153, 117, 255, 0.1);position:absolute;z-index:9;width: ` +
            Number(service_time) +
            "%" +
            `;left:calc(` +
            service_start_time +
            "%" +
            `);'><img style="position: absolute;left: 0;top: 0;width: 12px;" src='${require("../../assets/images/index/laber2.png")}'></div>`;
          // `<div class='Deliverfood' style='border-color: #907acc;bottom: 24px;border-style: solid;border-width: 0px 1px;background: rgba(153, 117, 255, 0.1);position:absolute;height:calc(100vh - 154px);z-index:9;width: `+service_time+'%'+`;left:calc(`+service_start_time+'%'+` + 60px);' >
          // <img style="position: absolute;left: 0;top: 0;width: 12px;" src='${require("../../assets/images/index/laber2.png")}'>
          // </div>`;
        });
      }
      console.log(service_html, "44444444444444");
      var container = document.getElementById("service_time");
      container.innerHTML = service_html;
    },

    //处理航班详情中的经纬点，按照echarts数据格式处理

    hanleFlightRoute(route) {
      this.pointtList = [];
      this.portalLinePoint = [];
      if (route.length > 0) {
        //遍历组成数据
        route.forEach((item, index) => {
          const array = {};
          const arr = [];
          const line = {};
          const line_data = [];
          const coords = [];
          const lineStyle = {};
          if(item.Lon.indexOf("E")>-1){
              arr[0] = item.Lon.split("E").join("");
          }else if(item.Lon.indexOf("W")>-1){
              arr[0] = -item.Lon.split("W").join("");
          }else{
             arr[0] = item.Lon
          }

         if(item.Lat.indexOf("N")>-1){
            arr[1] = item.Lat.split("N").join("");
         }else if(item.Lat.indexOf("S")>-1){
            arr[1] = -item.Lat.split("S").join("");
         }else{
            arr[1] = item.Lat;
         }

          // arr[2] = 0;
          array.point = arr;
          array.bump = "rgb(255,0,0)";
          var point_name = item.WaypointName.indexOf('@')<0?item.WaypointName+' ':' ';
          var time=item.WaypointName.indexOf('@')<0?item.CruiseTime:''
          array.point_name=point_name+time
          array.position=index% 2 === 0?'left':'right'
          this.pointtList.push(array);

          //计算颠簸度
          var fl_status = 0;
          if (Number(item.FlightLevel)) {
            //当飞机的飞行高度拥有确切数值
            var bump = this.common.findCloseNum(Number(item.FlightLevel)); //下标
            var fl_index = "FL" + bump;
          } else {
            //当飞机处于爬升或者下降过程中并没有一个确切的数值，默认取第一个高度点的颠簸值
            var fl_index = "FL050";
          }

          fl_status = Number(item[fl_index]); //对应的高度颠簸值
          array.fl_status = fl_status;
          if (fl_status > 0) {
            array.bump = this.bumoColor[fl_status];
            lineStyle.color = this.bumoColor[fl_status];
          } else {
            array.bump = "#FFFFFF";
            lineStyle.color = "#FFFFFF";
          }

          if (index < route.length - 1) {


            //经纬度坐标
            if(route[index + 1]["Lon"].indexOf("E")>-1){
                line_data[0] = route[index + 1]["Lon"].split("E").join("");
            }else if(route[index + 1]["Lon"].indexOf("W")>-1){
                line_data[0] = -route[index + 1]["Lon"].split("W").join("");
            }else{
                line_data[0] = route[index + 1]["Lon"];
            }

            if(route[index + 1]["Lat"].indexOf("N")>-1){
                line_data[1] = route[index + 1]["Lat"].split("N").join("");
            }else if(route[index + 1]["Lat"].indexOf("S")>-1){
                line_data[1] = -route[index + 1]["Lat"].split("S").join("");
            }else{
                 line_data[1] = route[index + 1]["Lat"];
            }


            coords.push(arr);
            coords.push(line_data);
            line.coords = coords;
            line.lineStyle = lineStyle;
            this.portalLinePoint.push(line);
          }
        });

        console.log("经纬点集合", this.pointtList);
        console.log("航线集合5556666", this.portalLinePoint);
      }
      this.setPortalPoint(true);

      this.$nextTick(() => {
        this.getBaseTexture();
      });
    },

    //根据航路点信息计算航路世界线
    countTimeList(route, trip) {
      //统计航路点时间集合

      //起飞前只取四个航路点
      // 1.计划起飞时间
      // 2.爬升TOC flightlevel
      // 3.计划下降TOD  flightlevel
      // 4.降落时间

      var arr = [];
      var time_list = "";
      var scale_list = "";

      this.timePercentList = [];
      this.timePointList = [];

      route.forEach((item, index) => {
        var array = {};
        array.time = item.CruiseTime;
        array.pointName = item.WaypointName;
        array.show = false;
        if (index === 0) {
          array.show = true;
        }
        if (index == route.length - 1) {
          array.time = trip;
          array.show = true;
        }
        if (item.WaypointName === "TOC" || item.WaypointName === "TOD") {
          array.show = true;
        }

        if (array.time) {
          arr.push(array);
        }
      });

      //计算平均占比
      var total_time = this.common.time_to_sec(trip);
      //面对百分百的航程，平均每一秒的百分比
      var average_percent = 100 / total_time;
      var last_time = "00:00:00";
      arr.forEach((item, index) => {
        var percent = 0;
        if (index > 0) {
          //当前时刻的
          var currnet_time = this.common.time_to_sec(item.time);
          //与上一个航路点的时间差
          if (item.show) {
            var pre_time = this.common.time_to_sec(last_time);
            var percent = (currnet_time - pre_time) * average_percent;
          }

          item.percent = currnet_time * average_percent;
        } else {
          var currnet_time = this.common.time_to_sec(item.time);
          item.percent = 0;
        }

        if (item.show) {
          last_time = item.time;
        }

        // if (!this.timePointList[parseInt(currnet_time)]) {
        this.timePointList[parseInt(currnet_time)] = item.pointName;
        // }

        this.timePercentList.push(parseInt(currnet_time));

        if (item.show) {
          time_list +=
            "<div class='time' style='color: rgba(255, 255, 255, 0.6);width:0; font-size: 12px;position: relative;margin-left:" +
            percent +
            "%" +
            "'>" +
            this.common.ForamtTime(item.time, 3) +
            "<div class='scalename-li'><div class='scalename'>" +
            item.pointName +
            "</div><div class='scalename-line'></div></div></div>";

          scale_list +=
            "<div class='scale' style='background:#9fa1a8;height:18px;width:1px;position:absolute;margin-left:" +
            currnet_time * average_percent +
            "%" +
            "'></div>";
        }
      });

      var time_scale = document.getElementById("time-bottom");
      var scale = document.getElementById("time—scale");

      scale.innerHTML = scale_list;
      time_scale.innerHTML = time_list;
    },

    //计算雷电气象时间
    countRainStorm(route, trip) {

      // const arr = [
      //   { name: 'Alice', age: 20 },
      //   { name: 'Charlie', age: 20 },
      //    { name: 'Bob', age: 21 },
      //   { name: 'David', age: 21 },
      //   { name: 'Eva', age: 22 },
      // ];

          const result = [];
          let lastGroup = null;
          route.forEach((item,index)=>{
            const group = item['Conv'];
            const array={}
            array.conv=item.Conv
            array.time=this.common.time_to_sec(item.CruiseTime)
            array.index=index
            if(item.Conv>0){
                if (group !== lastGroup) {
                  //补足末尾点位
                  if(result.length>0){
                    var last_lenght=result[result.length - 1].length
                    var last_index =result[result.length - 1][last_lenght-1]['index']
                    const end={}
                    end.conv=route[parseInt(last_index)+1]['Conv']
                    end.time=this.common.time_to_sec(route[parseInt(last_index)+1]['CruiseTime'])
                      end.index=parseInt(last_index)+1
                    console.log('末尾数组长度'+last_lenght,'末尾数组下标'+last_index)
                    result[result.length - 1].push(end)
                  }
                  result.push([array]);
                  lastGroup = group;

                } else {
                  result[result.length - 1].push(array);
                }
            }else{
              if(result.length>0 && lastGroup>0){
                var last_lenght=result[result.length - 1].length
                    var last_index =result[result.length - 1][last_lenght-1]['index']
                    const end={}
                    end.conv=route[parseInt(last_index)+1]['Conv']
                    end.time=this.common.time_to_sec(route[parseInt(last_index)+1]['CruiseTime'])
                      end.index=parseInt(last_index)+1
                    console.log('末尾数组长度'+last_lenght,'末尾数组下标'+last_index)
                    result[result.length - 1].push(end)
              }
              lastGroup=null
            }
          })

          console.log(result,'47558676')

          //计算总时长
          var total_time = this.common.time_to_sec(trip);
          //面对百分百的航程，平均每一秒的百分比
          var average_percent = 100 / total_time;
          var html = "";
          //计算雷雨分布的时间范围，并映射到页面上
          if(result.length>0){
            result.forEach((val,index)=>{
                var start_tiem=val[0]['time']
                var end_time=val[val.length-1]['time']
                var cost_time = parseInt(end_time) - parseInt(start_tiem);
                var percent = cost_time * average_percent;
                var left = parseInt(start_tiem) * average_percent;
                if(val[0]['conv']==1){
                  html +=
                    `<div class='rainstorm-box' style='mix-blend-mode: normal;transform: matrix(-1, 0, 0, 1, 0, 0);border-color: #7accb8;top: 0;border-style: solid;border-width: 0px 0.5px;background: rgba(107, 178, 161, 0.4);position:absolute;height:100%;width: ` +
                    percent +
                    "%" +
                    `;left:` +
                    left +
                    "%" +
                    `;' >
                  <img style="position: absolute;width: 1.15vw;top: -0.08vw;right: -0.57vw;" src='${require("../../assets/images/index/laber1.png")}'>
                  </div>`;
                }else if(val[0]['conv']==2){
                  html +=
                    `<div class='rainstorm-box' style='mix-blend-mode: normal;transform: matrix(-1, 0, 0, 1, 0, 0);border-color: #dc5357;top: 0;border-style: solid;border-width: 0px 0.5px;background: rgba(220,83,87, 0.2);position:absolute;height:100%;width: ` +
                    percent +
                    "%" +
                    `;left:` +
                    left +
                    "%" +
                    `;' >
                  <img style="position: absolute;width: 1.15vw;top: -0.08vw;right: -0.57vw;" src='${require("../../assets/images/index/set6.png")}'>
                  </div>`;
                }

            })
          }
          var containr = document.getElementById("rainstorm");
          containr.innerHTML = html;
return false
      //计算总时长
      var total_time = this.common.time_to_sec(trip);
      //面对百分百的航程，平均每一秒的百分比
      var average_percent = 100 / total_time;
      var html = "";
      route.forEach((item, index) => {
        var next_index = parseInt(index + 1);
        if (index == route.length - 1) {
          var point_time = this.common.time_to_sec(trip);
          var next_point_time = this.common.time_to_sec(trip);
        } else {
          var point_time = this.common.time_to_sec(item.CruiseTime);
          var next_point_time = this.common.time_to_sec(
            route[next_index]["CruiseTime"]
          );
        }

        //  <div class="rainstorm-box">
        //                 <img src="@/assets/images/index/laber1.png" />
        //               </div>
        var cost_time = parseInt(next_point_time) - parseInt(point_time);
        var percent = cost_time * average_percent;
        var left = parseInt(point_time) * average_percent;
        //检索雷雨气象 0 无雷雨 1轻度雷雨 2重度雷雨
        if (item.Conv > 0) {
          html +=
            `<div class='rainstorm-box' style='mix-blend-mode: normal;transform: matrix(-1, 0, 0, 1, 0, 0);border-color: #7accb8;top: 0;border-style: solid;border-width: 0px 0.5px;background: rgba(107, 178, 161, 0.4);position:absolute;height:100%;width: ` +
            percent +
            "%" +
            `;left:` +
            left +
            "%" +
            `;' >
          <img style="position: absolute;width: 1.15vw;top: -0.08vw;right: -0.57vw;" src='${require("../../assets/images/index/laber1.png")}'>
          </div>`;
        }
      });

      var containr = document.getElementById("rainstorm");
      containr.innerHTML = html;
    },

    //根据航路点位信息计算航程颠簸数据
    countPortalBump(route, trip) {
      this.timeBumpList = [];
      //计算总时长
      var total_time = this.common.time_to_sec(trip);
      //面对百分百的航程，平均每一秒的百分比
      var average_percent = 100 / total_time;
      // console.log(average_percent,'平均占比')
      //遍历计算每个航路点所占总时长的百分比
      var html = ""; //航线html

      var time_list = [];
      var pre_time_margin = 0;
      route.forEach((item, index) => {
        // if (index > 0) {
        //下一个航路点的下标
        var next_index = parseInt(index + 1);
        if (index == route.length - 1) {
          var point_time = this.common.time_to_sec(trip);
          var next_point_time = this.common.time_to_sec(trip);
        } else {
          var point_time = this.common.time_to_sec(item.CruiseTime);
          var next_point_time = this.common.time_to_sec(
            route[next_index]["CruiseTime"]
          );
        }

        var cost_time = parseInt(next_point_time) - parseInt(point_time);
        // } else {
        //   var cost_time = this.common.time_to_sec(item.CruiseTime);
        // }

        //计算航路点的颠簸值
        //获取当前坐标所在高度的颠簸状况
        var fl_status = 0;
        if (Number(item.FlightLevel)) {
          //当飞机的飞行高度拥有确切数值
          var index = this.common.findCloseNum(Number(item.FlightLevel)); //下标
          var fl_index = "FL" + index;
        } else {
          //当飞机处于爬升或者下降过程中并没有一个确切的数值，默认取第一个高度点的颠簸值
          var fl_index = "FL050";
        }

        fl_status = Number(item[fl_index]); //对应的高度颠簸值
        this.timeBumpList[point_time] = fl_status;

        var percent = cost_time * average_percent;

        //计算航路点时刻在刻度线上占的百分比

        html +=
          "<div class='head-line' style='background:" +
          this.bumoColor[fl_status] +
          ";height: 12px;width: " +
          percent +
          "%" +
          ";'></div>";
      });

      var portal = document.getElementById("portal");

      portal.innerHTML = html;
    },

    //计算各个航路点时刻下的不同高度层的颠簸值
    countLevelBump(route, trip) {
      //计算总时长
      var total_time = this.common.time_to_sec(trip).toFixed(3);

      //面对百分百的航程，平均每一秒的百分比
      var average_percent = 100 / total_time;

      //遍历高度层
      this.flightLevelList.forEach((val, key) => {
        //遍历航路点数据
        // if (key > 0) {
        //   return false;
        // }
        var arr = [];
        var count = 0;
        route.forEach((item, index) => {
          // if (index > 0) {
          //下一个航路点的下标
          var next_index = parseInt(index + 1);
          if (index == route.length - 1) {
            var point_time = this.common.time_to_sec(trip);
            var next_point_time = this.common.time_to_sec(trip);
          } else {
            var point_time = this.common.time_to_sec(item.CruiseTime);
            var next_point_time = this.common.time_to_sec(
              route[next_index]["CruiseTime"]
            );
          }

          // var last_point_time = this.common.time_to_sec(
          //   route[last_index]["CruiseTime"]
          // );
          var cost_time = parseInt(next_point_time) - parseInt(point_time);
          // } else {
          //   var cost_time = this.common.time_to_sec(item.CruiseTime);
          // }
          //时刻"<div class='flight-li' style='background: #DC5357;height: 8px;width: 30%;float: left;'></div>"
          var percent = cost_time * average_percent;

          count = parseFloat(count) + parseFloat(percent);
          // console.log(index, percent, count);
          //  percent=1.5
          var fl_status = item[val]; //对应的高度颠簸值

          //计算高度线坐标，宽，边距，高度
          var height_level_html = "";
          if (Number(item.FlightLevel)) {
            //当飞机的飞行高度拥有确切数值
            var index_t = this.common.findCloseNum(Number(item.FlightLevel)); //下标
            var fl_index = "FL" + index_t;
          } else {
            //当飞机处于爬升或者下降过程中并没有一个确切的数值，默认取第一个高度点的颠簸值
            var fl_index = "FL050";
          } //根据flightlevel推算出相距最近的高度层，当外层便利的高度值和这里的一致时，开始描述高度线
          if (fl_index === val) {
            //这里要判断下一个点位是不是同一个高度层，
            if (index < route.length - 1) {
              var next_point_FlightLevel =
                route[parseInt(index) + 1]["FlightLevel"];
              if (Number(next_point_FlightLevel)) {
                var index2 = this.common.findCloseNum(Number(item.FlightLevel)); //下标
                var fl_index2 = "FL" + index2;
              } else {
                var fl_index2 = "FL050";
              }

              if (fl_index == fl_index2) {
                height_level_html =
                  "<div style='top:4.5px;width: 100%;height: 1px;background: #3787FF;position: absolute;'></div>";
                // console.log(
                //   index,
                //   fl_index,
                //   fl_index2,
                //   height_level_html,
                //   "height-line"
                // );
              }
            }
          }

          var html =
            "<div class='flight-li' style='position: relative;height: 8px;float: left;width:" +
            percent +
            "%" +
            ";background:" +
            this.bumoColor[fl_status] +
            ";'>" +
            height_level_html +
            "</div>";
          // <div style='top:3.5px;width: 100%;height: 1px;background: #3787FF;position: absolute;'></div><div style='width: 1px;background: #3787ff;position: absolute;height: 23px;bottom: 4.5px;right: 0;'></div>
          arr.push(html);
        });

        this.bumpLevel[val] = arr;

        //
      });
      console.log(this.bumpLevel, "4545656");
    },

    //搜索的航班历史，判断其在当前时刻的颠簸状态
    startHistoryBumpCount() {
      if (this.labelList.length <= 0) {
        return false;
      }
      //开启定时任务
      //  1.判断与当前时间比较，航班的状态是飞行前、飞行后、飞行中三者中的一个
      //  2.若是飞行前或者是飞行后的航班，颠簸状态可忽略至0
      //  3.当航班处于飞行中时
      this.intervalContainer();
      this.timer = setInterval(() => {
        this.intervalContainer();
      }, 60000);
    },

    //定时任务内容主体
    intervalContainer() {
      this.labelList.forEach((item, index) => {
        //当前时间
        var now_time = Date.parse(new Date());
        //把日期转换为时间戳方便比较
        var etd_time = new Date(item.etd_time).getTime();
        var land_time = new Date(item.land_time).getTime();

        if (now_time <= etd_time) {
          console.log("起飞前");
          //起飞前
          item.situation = 0;
          this.timerCountFlightBump(item, index, 0);
        } else if (now_time > land_time) {
          //飞行后（已落地）
          item.situation = 0;
          this.delWarningFlight(item, 0);
          this.delWarningFlight(item, 2);
        } else {
          console.log('飞行中',item.name)
          //飞行中
          this.timerCountFlightBump(item, index, 2);
        }
      });

      this.$storage.set("flightHistory", this.labelList);
    },

    //定时任务中计算航班的颠簸状态
    //item,搜索的历史航班数据
    //index，数据在labellist中的下标，因为要用到下标为数据situation赋值
    //飞行状态 0飞行前1飞行后(已落地)2飞行中
    timerCountFlightBump(item, index, type = 0) {
      var now_time = Date.parse(new Date());
      var etd_time = new Date(item.etd_time).getTime();

      var info = item["RouteInformation"];
      var time_list = []; //航路时刻集合
      var time_bump = []; //时刻颠簸集合
      var fl_status_list = []; //颠簸值集合

      //遍历航路点取颠簸值
      info.forEach((val, index) => {
        var fl_status = 0;
        var point_time = this.common.time_to_sec(val.CruiseTime);
        if (Number(val.FlightLevel)) {
          //当飞机的飞行高度拥有确切数值
          var index = this.common.findCloseNum(Number(val.FlightLevel)); //下标
          var fl_index = "FL" + index;
        } else {
          //当飞机处于爬升或者下降过程中并没有一个确切的数值，默认取第一个高度点的颠簸值
          var fl_index = "FL050";
        }

        fl_status = Number(val[fl_index]); //对应的高度颠簸值
        time_list.push(point_time);
        time_bump[point_time] = fl_status;
        fl_status_list.push(fl_status);
      });

      if (type == 0) {
        //飞行前，需要判断航路点中是否存在颠簸状态，是否需要进行飞行前告警
        if (fl_status_list.indexOf(3) >= 0 || fl_status_list.indexOf(4) >= 0) {
          //需要进行航班告警

          item.bump=Math.max.apply(null,fl_status_list)
          // console.log("需要飞行前告警航班",item);
          if (this.foreWarningFlight.length <= 0) {

            this.foreWarningFlight.push(item);
            this.countFlightBumpTotal()
          } else {
            this.addWarningFlight(item, 0);
          }
        }
      } else if (type == 2) {
        //飞行中的航班先从飞行前的预警列表中移除，避免数据重复
        this.delWarningFlight(item, 0);
        var point = parseInt(now_time - etd_time) / 1000;
        var bump_index = this.common.findCloseNum(point, 0, time_list);
        this.labelList[index]["situation"] = time_bump[bump_index];
        this.delWarningFlight(item, 2);
        if (time_bump[bump_index] > 2) {
          //颠簸系数大于0，添加到告警航班中
          item.bump=time_bump[bump_index]

          if (this.WarningFlight.length <= 0) {

            this.WarningFlight.push(item);
            this.countFlightBumpTotal()
          } else {
            this.addWarningFlight(item, 2);
          }
        }
      }

    },

    //添加预警航班数据
    addWarningFlight(item, type = 0) {
      var data = null;
      if (type == 0) {
        data = this.foreWarningFlight;
      } else {
        data = this.WarningFlight;
      }
      var flight_list = [];
      var item_etd_time = new Date(item.etd_time).getTime();
      var item_flight = item.name;
      var item_val = item_flight + item_etd_time;
      for (let i = 0; i < data.length; i++) {
        var flight_num = data[i]["name"];
        var etdtime = new Date(data[i]["etd_time"]).getTime();
        var info = flight_num + etdtime;
        flight_list.push(info);

      }

      if (flight_list.indexOf(item_val) < 0) {
        //添加告警航班
        if (type == 0) {
          this.foreWarningFlight.push(item);
        } else {
          this.WarningFlight.push(item);
        }
      }

      this.countFlightBumpTotal()
    },

    //判断飞行前和飞行中，重度和中度颠簸的航班统计情况
    countFlightBumpTotal(){

        var fore_moderate=0
        var fore_serious=0
        var warn_moderate=0
        var warn_serious=0
        //飞行前
        this.foreWarningFlight.forEach((val,key)=>{
          if(val.bump==3){
            fore_moderate+=1
          }else if(val.bump==4){
            fore_serious+=1
          }
        })

        //飞行中
        this.WarningFlight.forEach((item,index)=>{
          if(item.bump==3){
              warn_moderate+=1
          }else if(item.bump==4){
              warn_serious+=1
          }
        })

        this.foreWarning.moderate=fore_moderate
        this.foreWarning.serious=fore_serious
        this.warning.moderate=warn_moderate
        this.warning.serious=warn_serious
    },

    //删除预警航班数组
    delWarningFlight(item, type = 0) {
      var data = null;
      if (type == 0) {
        data = this.foreWarningFlight;
      } else {
        data = this.WarningFlight;
      }
      if (data.length <= 0) {
        return false;
      }
      for (let i = 0; i < data.length; i++) {
        if (
          data[i]["name"] == item.name &&
          data[i]["etd_time"] == item.etd_time
        ) {
          if (type == 0) {
            this.foreWarningFlight.splice(i, 1);
          } else {
            this.WarningFlight.splice(i, 1);
          }
        }
      }

      this.countFlightBumpTotal()
    },

    //点击开启时间选择
    openSetTime() {
      this.dialogVisible5 = true;
      for (let i = 0; i < this.labelList.length; i++) {
        if (this.labelList[i]["active"]) {
          if (this.labelList[i]["actual_etd_time"]) {
            this.actual_etd_time = this.labelList[i]["actual_etd_time"];
          } else {
            this.actual_etd_time = "";
          }
        }
      }
    },
    //手动设置实际起飞时间，搜索历史的韩版设置各自的实际起飞时间
    setActualEtdTime() {
      //遍历当前选中的搜索航班，为其设置实际起飞时间
      for (let i = 0; i < this.labelList.length; i++) {
        if (this.labelList[i]["active"]) {
          console.log(this.labelList[i], "当前选中的航班");
          //当前选中的航班，更改其时间
          this.labelList[i]["actual_etd_time"] = this.actual_etd_time;
          this.flightDeailInfo.actual_etd_time = this.actual_etd_time;
          var etd_time_stamp = new Date(this.actual_etd_time).getTime();
           //转换时区
          var time_zone = this.common.getTimeZone();
          etd_time_stamp += time_zone * 3600 * 1000;
          // this.labelList[i]["etd"] = this.actual_etd_time;
          this.labelList[i]["time"] = this.common.FormTimeStamp(etd_time_stamp);
          this.labelList[i]["etd_time_hs"] = this.common.FormTimeStamp(
            etd_time_stamp,
            2
          );
          this.labelList[i]["etd_time_hs"] = this.common.FormTimeStamp(
            etd_time_stamp,
            3
          );


          //落地时间戳
          var land_time_stamp =
            etd_time_stamp +
            this.common.time_to_sec(this.labelList[i]["TripTime"]) * 1000;
          this.labelList[i]["land_time"] = this.common.FormTimeStamp(
            land_time_stamp,
            3
          );
          this.labelList[i]["land_time_hs"] = this.common.FormTimeStamp(
            land_time_stamp,
            2
          );
          this.$storage.set("flightDetail", this.labelList[i]);
          this.handleFlighrDetail(true);
        }
      }
      console.log(this.labelList,'设定后的搜索历史')
      this.$storage.set("flightHistory", this.labelList);
      this.dialogVisible5 = false;
    },

    //控制放大/缩放地球大小
    operateDistance(type) {
      if (type == 0) {
        //缩放
        this.earth_distance += 50;
      } else {
        //放大
        if (this.earth_distance <= 0) {
          this.earth_distance = 0;
        } else {
          this.earth_distance -= 50;
        }
      }
      this.$nextTick(() => {
        this.getBaseTexture();
      });
    },

    //3D地球把相机焦点定位到航线上
    setPortalPoint(is_set = false) {
      if (!is_set) {
        this.targetCoord = [116, 39];
      } else {
        if (this.flightDeailInfo) {
          this.targetCoord = [];
          var routeInfo = this.flightDeailInfo.RouteInformation;

          var index = Math.round((routeInfo.length - 1) / 2);
          console.log(routeInfo[index], "546848488449");

          if(routeInfo[index]["Lon"].indexOf("E")>-1){
            this.targetCoord[0] = parseFloat(
            routeInfo[index]["Lon"].split("E").join("")
            );
          }else if(routeInfo[index]["Lon"].indexOf("W")>-1){
            this.targetCoord[0] = -parseFloat(
            routeInfo[index]["Lon"].split("W").join("")
            );
          }else{
            this.targetCoord[0] = parseFloat(
            routeInfo[index]["Lon"]
            );
          }

          if(routeInfo[index]["Lat"].indexOf("N")>-1){
              this.targetCoord[1] = parseFloat(
            routeInfo[index]["Lat"].split("N").join("")
              );
          }else if(routeInfo[index]["Lat"].indexOf("S")>-1){
              this.targetCoord[1] = -parseFloat(
            routeInfo[index]["Lat"].split("S").join("")
              );
          }else{
              this.targetCoord[1] = parseFloat(
            routeInfo[index]["Lat"]
              );
          }

        }
      }

      this.$nextTick(() => {
        this.getBaseTexture();
      });
    },

    // 生成球面纹理
    getBaseTexture() {
      // 获取地图数据的URL或本地路径
      const mapData = require("@/assets/countries.geo.json");

      // 注册地图数据
      echarts.registerMap("customMap", mapData);

      let canvas = document.createElement("canvas");
      let baseTexture = echarts.init(canvas, null, {
        width: 4096,
        height: 2048,
      });

      // 关闭信息弹框
      baseTexture.on('mouseover', function (params) {
        console.log(params,'45645646464646464694')
        if (params.componentType === 'geo') {
          baseTexture.dispatchAction({type: 'hideTip'});
        }
      });

      baseTexture.setOption({
        backgroundColor: "#001420",
        geo: {
          type: "map",
          map: "customMap",
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          boundingCoords: [
            [-180, 90],
            [180, -90],
          ],
          roam: false,
          itemStyle: {
            normal: {
              areaColor: "#0B232E",
              borderColor: "#2289AB",
            },
            emphasis: {
              areaColor: "#0B232E",
              // areaColor: "#1E6180"
            },
          },
          label: {
            normal: {
              fontSize: 16,
              show: false,
              textStyle: {
                color: "#269DC6",
              },
            },
            emphasis: {
              fontSize: 30,
              show: false,
              textStyle: {
                color: "#fff",
              },
            },
          },
        },
      });

      this.drawEarth(baseTexture);
    },
    // 使用生成的纹理绘制地球
    drawEarth(baseTexture) {
      // 获取chart容器的DOM元素
      const chartContainer = this.$refs.chartContainer;

      // 如果已经有一个图表实例，先销毁它
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }

      // 创建基于DOM元素的ECharts实例
      this.chart = echarts.init(chartContainer);

      const option = {
        tooltip: {
          show: true,
          borderColor: "rgba(255,255,255,.3)",
          backgroundColor: "rgba(13,5,30,.6)",
          borderWidth: 1,
          padding: 5,
          confine: true,
          textStyle: {
            color: "#fff",
          },
        },
        globe: {
          baseTexture: baseTexture,
          shading: "lambert",
          globeRadius: 130,
          light: {
            main: {
              color: "#fff",
              intensity: 0.8,
              alpha: 40,
              beta: -30,
            },
            ambient: {
              color: "#fff",
              intensity: 1,
            },
          },
          viewControl: {
            alpha: 35,
            beta: 190,
            autoRotate: false,
            autoRotateAfterStill: 10,
            distance: this.earth_distance,
            targetCoord: this.targetCoord,
          },
        },
        series: [
          {
            type: "scatter3D",
            coordinateSystem: "globe",
            blendMode: "lighter",
            symbolSize: 5,
            label: {
            show: true,
            formatter: '{b}',
            position: 'left',
            color: '#fff'
            },
            // 经纬度坐标
            data: this.pointtList.map((item) => {
              return {
                name: item.point_name,
                value: item.point,
                symbolSize: item.fl_status > 0 ? 10 : 5,
                label:{color:item.bump,position: item.position,},
                itemStyle: {
                  color: item.bump,
                  // opacity: 0.8
                },
              };
            }),
          },
          //地球表面绘制线
          {
            name: "航班路线",
            type: "lines3D",
            coordinateSystem: "globe",
            effect: {
              show: true,
            },
            blendMode: "lighter",
            lineStyle: {
              width: 3,
              color: "#2289AB",
            },
            data: this.portalLinePoint,

            silent: false,
          },
        ],
      };

      // 使用配置项绘制图表
      this.chart.setOption(option);
    },
    resizeChart() {
      // 当窗口大小变化时，调用图表实例的resize方法以重新渲染图表
      if (this.chart) {
        this.chart.resize();
      }
    },
    //查看告警航班详情
    readWarningFlightDetail(item) {
      //搜索历史高亮效果
      for (let i = 0; i < this.labelList.length; i++) {
        if (
          this.labelList[i]["name"] == item.name &&
          this.labelList[i]["etd_time"] == item.etd_time
        ) {
          this.labelList[i].active = true;
        } else {
          this.labelList[i].active = false;
        }
      }

      const param = {};
      param.flgtno = item.name;
      param.flgtetd = item.etd;

      //搜索航班信息

      this.queryFlightDetail(param, true);
      //关闭告警航班弹框
      this.dialogVisible = false;
    },
    //点击高亮
    laberactive(index, item) {
      for (let i = 0; i < this.labelList.length; i++) {
        this.labelList[i].active = i == index ? true : false;
      }
      this.$storage.set("flightHistory", this.labelList);
      const param = {};
      param.flgtno = item.name;
      param.flgtetd = item.etd;
      param.actual_etd_time = item.actual_etd_time;
      //点击搜索航班信息

      this.queryFlightDetail(param, true);
    },
    // 删除
    del(item) {
      for (let i = 0; i < this.labelList.length; i++) {
        if (this.labelList[i] == item) {
          this.labelList.splice(i, 1);
        }
      }

      this.$storage.set("flightHistory", this.labelList);
    },
    // 移入
    mouseOver() {
      this.moreshow = true;
    },
    // 移出
    mouseLeave() {
      // setTimeout(()=>{
      //   this.moreshow = false
      // },2000)
      this.moreshow = false;
    },
    startDrag(event) {
      event.preventDefault();
      this.isDragging = true; // 开始拖拽
      if (event.type === "touchstart") {
        // 移动端触摸事件
        this.startX = event.touches[0].clientX; // 记录触摸点的初始X坐标
        this.startY = event.touches[0].clientY; // 记录触摸点的初始Y坐标
        // 添加触摸事件监听器
        document.addEventListener("touchmove", this.handleDrag);
        document.addEventListener("touchend", this.endDrag);
      } else {
        // 鼠标事件
        this.startX = event.clientX; // 记录鼠标点击时的初始X坐标
        this.startY = event.clientY; // 记录鼠标点击时的初始Y坐标
        // 添加鼠标事件监听器
        document.addEventListener("mousemove", this.handleDrag);
        document.addEventListener("mouseup", this.endDrag);
      }
    },
    handleDrag(event) {
      if (this.isDragging) {
        let clientX, clientY;
        if (event.type === "touchmove") {
          clientX = event.touches[0].clientX; // 移动端触摸事件的X坐标
          clientY = event.touches[0].clientY; // 移动端触摸事件的Y坐标
        } else {
          clientX = event.clientX; // 鼠标事件的X坐标
          clientY = event.clientY; // 鼠标事件的Y坐标
        }
        let deltaX = clientX - this.startX; // 计算移动距离的X分量
        let deltaY = clientY - this.startY; // 计算移动距离的Y分量

        this.left += deltaX; // 更新拖拽元素的左边距
        this.top += deltaY; // 更新拖拽元素的上边距

        if (this.left <= 40) {
          this.left = 40;
        }
        if (this.left >= 590) {
          this.left = 590;
        }

        var ll = (this.left - 40) / 550;
        var ls = ll * this.common.time_to_sec(this.flightDeailInfo.TripTime);
        var time_index = this.common.findCloseNum(
          parseInt(ls),
          0,
          this.timePercentList
        );

        var point_name = this.timePointList[time_index];
        if (point_name.indexOf("@") >= 0) {
          point_name = "";
        }
        this.Waypoint =
          this.common.ForamtTime(time_index, 3, true) + point_name;

        this.startX = clientX; // 更新初始X坐标
        this.startY = clientY; // 更新初始Y坐标
      }
    },

    endDrag() {
      this.isDragging = false; // 结束拖拽

      document.removeEventListener("touchmove", this.handleDrag); // 移除触摸移动事件监听器
      document.removeEventListener("touchend", this.endDrag); // 移除触摸结束事件监听器
      document.removeEventListener("mousemove", this.handleDrag); // 移除鼠标移动事件监听器
      document.removeEventListener("mouseup", this.endDrag); // 移除鼠标释放事件监听器
    },
  },
};
</script>
<style lang="less">
html {
  background: #262d40;
}
.scalename-li {
  position: absolute;
  z-index: 9;
  width: 50px;
  left: -10px;
  top: -51px;
}
.scalename {
  transform: rotate(-45deg);
  color: #839fc0;
  font-size: 11px;
  margin-bottom: 12px;
}
.scale:before {
  content: "";
  background: #9fa1a8;
  display: block;
  position: absolute;
  width: 6px;
  height: 6px;
  transform: rotate(-45deg);
  top: 0;
  left: calc(50% - 3px);
}
</style>
<style lang="less" scoped>
/deep/.chart-container div {
  z-index: 3;
  width: 100% !important;
  canvas{
    width: 100% !important;
  }
}
/deep/.alarm-box .el-dialog__header {
  display: none;
}
/deep/.alarm-box .el-dialog {
  position: absolute;
  margin-top: 0 !important;
  right: 0;
  background: #262d40;
  box-shadow: 0px 23px 33px rgba(18, 21, 30, 0.794744);
  height: 100%;
  width: 600px;
}
/deep/.alarm-box .el-dialog__body {
  padding: 0;
  text-align: left;
  color: #fff;
}
.ScreenAdapter {
  transform-origin: 0 0;
  position: absolute;
  left: 50%;
  top: 50%;
  transition: 0.3s;
  background: red;
}
.operation-img {
  width: 100%;
  height: 95%;
  box-sizing: border-box;
}
.chart-container {
  width: 100%;
  height: 100%;
}
.interaction-head {
  font-size: 16px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modalclose {
  position: absolute;
  width: 20px;
  top: 22px;
  right: 16px;
  cursor: pointer;
}
/deep/.interaction .el-dialog__header {
  display: none;
}
/deep/.interaction .el-dialog {
  position: absolute;
  margin-top: 0 !important;
  background: url("~@/assets/images/index/xian.png") no-repeat #262d40;
  background-size: 100% 100%;
  box-shadow: 0px 23px 33px rgba(18, 21, 30, 0.794744);
  width: 500px;
  left: calc(50% - 250px);
  top: calc(30%);
  border-radius: 8px;
  padding-bottom: 24px;
  .el-input__inner {
    height: 48px;
    background: #262d40;
    border: 1px solid #525f89;
    border-radius: 8px;
    color: #fff;
  }
  .el-textarea__inner {
    background: #262d40;
    border: 1px solid #525f89;
    border-radius: 8px;
    height: 168px;
    color: #fff;
    font-size: 16px;
  }
  .el-select {
    width: 100%;
  }
}
/deep/.interaction.ac1 .el-dialog {
  width: 425px;
  left: calc(50% - 212.5px);
  .interaction-box {
    padding-bottom: 0;
  }
  .interaction-li {
    margin-bottom: 36px;
  }
}
/deep/.interaction.acc2 .el-dialog {
  top: 20%;
}
/deep/.interaction .el-dialog__body {
  padding: 0;
  text-align: left;
  color: #fff;
}
@keyframes rotate {
  0% {
    transform: perspective(400px) rotateZ(20deg) rotateX(-40deg) rotateY(0);
  }
  100% {
    transform: perspective(400px) rotateZ(20deg) rotateX(-40deg)
      rotateY(-360deg);
  }
}
.fj {
  background: #0f1526;
  height: 24px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  .fj-box {
    position: absolute;
  }
  .fj-line {
    display: block;
    width: 1px;
    background: #8db1d1;
    height: calc(100vh - 154px);
    position: absolute;
    bottom: 24px;
    left: 50%;
  }
  .fj-time::before {
    content: "";
    display: block;
    border-top: 7px solid #bdcddb;
    border-right: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-left: 7px solid transparent;
    position: absolute;
    transform: translate(-50%);
    left: 50%;
    bottom: -10px;
  }
  .fj-time {
    background: #bdcddb;
    position: absolute;
    bottom: calc(100vh - 122px);
    height: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    color: #33343c;
    font-size: 14px;
    white-space: nowrap;
    transform: translate(-50%);
    left: 50%;
  }
  .fjimg {
    cursor: pointer;
    width: 41px;
    display: block;
    z-index: 99;
  }
}
.flight-left {
  height: 100%;
  width: 60px;
}
.bumpprevention-right {
  width: 628px;
}
.time-bottom {
  width: 550px;
}
.flight-ul {
  width: 550px;
}
.time-top {
  display: flex;
  align-items: flex-end;
  width: 550px;
  justify-content: space-between;
  padding-top: 4px;
  border-bottom: 1px solid #9fa1a8;
  margin-left: 60px;
  .scale {
    width: 1px;
    background: #9fa1a8;
    height: 6px;
  }
  .scale:nth-child(2n-1) {
    height: 10px;
  }
  .scale:first-child {
    height: 8px;
  }
  .scale:last-child {
    height: 8px;
  }
}
.ecahrts-li{
  width: 260px;
}
.stars {
  transform: perspective(500px);
  transform-style: preserve-3d;
  position: absolute;
  perspective-origin: 50% 100%;
  left: 45%;
  animation: rotate 90s infinite linear;
  bottom: 0;
}
.star {
  width: 2px;
  height: 2px;
  background: #aeb1b6;
  position: absolute;
  left: 0;
  top: 0;
  backface-visibility: hidden;
}
.briefnote-box {
  .briefnote-bottom {
    padding: 24px;
    height: 350px;
    overflow: auto;
    .briefnote-head {
      opacity: 0.87;
      font-size: 14px;
    }
    .briefnote-p {
      font-size: 14px;
      line-height: 22px;
      /* or 157% */
      color: #ffffff;
      opacity: 0.6;
      margin-top: 16px;
    }
  }
  .briefnote-top {
    display: flex;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid #1a2133;
    .briefnote-li {
      width: 25%;
      text-align: center;
      .briefnote-h.active {
        color: #8ebf86;
      }
      .briefnote-h {
        color: rgba(255, 255, 255, 0.87);
        opacity: 0.87;
        text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
        font-size: 16px;
        margin-bottom: 8px;
      }
      .briefnote-p {
        color: rgba(255, 255, 255, 0.87);
        opacity: 0.6;
        text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
        font-size: 12px;
      }
    }
  }
}
.aboutus-box {
  margin-top: 112px;
  text-align: center;
  img {
    width: 72px;
  }
  .aboutus-h {
    font-size: 16px;
    margin-top: 24px;
    margin-bottom: 12px;
  }
  .aboutus-p {
    opacity: 0.6;
    font-size: 12px;
  }
}
.aboutus-laber {
  opacity: 0.6;
  font-size: 12px;
  text-align: center;
  margin-top: 116px;
}
.interaction-bt.active {
  background: #2769ec;
  border: 1px solid #2769ec;
  margin-right: 12px;
}
.hq {
  position: absolute;
  color: #83acfe;
  font-size: 14px;
  right: 16px;
  top: 1px;
  line-height: 46px;
  background: #262d40;
  cursor: pointer;
  padding-left: 10px;
}
.interaction-box {
  padding: 24px;
  .interaction-li:last-child {
    margin-bottom: 0;
  }
  .interaction-li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 24px;
    .interaction-left {
      width: 120px;
      text-align: right;
      font-size: 16px;
    }
    .interaction-left.active {
      line-height: 48px;
    }
    .interaction-right {
      flex: 1;
      position: relative;
    }
  }
}
.bt-box {
  display: flex;
  align-items: center;
  margin-left: 144px;
}
.bt-box.active {
  justify-content: center;
  margin: 0;
  margin-top: 24px;
}
.interaction-bt {
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 28px;
  cursor: pointer;
  width: 120px;
}
.alarm.active {
  border-top: 1px solid #0f1526;
  margin-top: 24px;
  .alarm-ul {
    height: 100%;
  }
}
.modal-top.active {
  border: none;
}
.search {
  background: #0e1630;
  opacity: 0.8;
  border-radius: 8px;
  display: flex;
  align-items: center;
  height: 45px;
  padding: 0 12px;
  width: calc(100% - 32px);
  margin: auto;
  box-sizing: border-box;
  img {
    width: 20px;
    margin-right: 12px;
  }
  input {
    font-size: 16px;
    flex: 1;
    background: none;
    border: none;
    height: 40px;
    color: #fff;
    outline-style: none;
  }
}
.set-li.active2 {
  padding: 0 16px !important;
}
.set-li.active {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  img {
    width: 20px;
  }
}
.translation-li:last-child {
  border: none;
}
.translation-li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.5px solid #4e5366;
  height: 64px;
  cursor: pointer;
  .translation-left {
    display: flex;
    align-items: center;
    img {
      width: 24px;
      margin-right: 8px;
    }
  }
  img {
    width: 20px;
  }
}
.feedback-box {
  display: flex;
  align-items: center;
  img {
    width: 32px;
  }
  .feedback-text {
    margin-left: 12px;
    .feedback-h {
      font-size: 16px;
      margin-bottom: 8px;
    }
    .feedback-p {
      font-size: 12px;
      opacity: 0.6;
      font-size: 12px;
    }
  }
}
.situation-h {
  font-size: 16px;
  opacity: 0.87;
  margin-bottom: 12px;
  margin-top: 18px;
}
.situation-p {
  font-size: 12px;
  margin-top: 24px;
}
.situation-line {
  background: linear-gradient(
    90deg,
    #8ebf86 13.47%,
    #edd977 37.81%,
    #eba967 66.94%,
    #e07073 87.51%
  );
  border-radius: 6px;
  height: 4px;
  position: relative;
  .situation {
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ffffff;
    border: 1px solid #3f7cf6;
    top: -3px;
  }
}
.legend-ul {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .legend-li {
    width: 25%;
    margin-top: 16px;
    display: flex;
    align-items: center;
    img {
      width: 20px;
      margin-right: 4px;
      display: block;
    }
    span {
      font-size: 14px;
      color: #ffffff;
      opacity: 0.87;
      line-height: 16px;
    }
  }
}
.set-box {
  padding: 16px;
  .set-li {
    background: #393f52;
    border: 1px solid #525f89;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    .set-laber {
      color: #ffffff;
      display: flex;
      align-items: center;
      opacity: 0.6;
      font-size: 12px;
      img {
        width: 16px;
        margin-right: 4px;
      }
    }
  }
}
.alarm-time.active{
  display: block;
  .time-li {
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-right: 0;
  }
}
.alarm-time {
  display: flex;
  align-items: center;
  .time-li {
    display: flex;
    align-items: center;
    margin-right: 40px;
    img {
      width: 16px;
    }
    span {
      margin-left: 8px;
      font-size: 16px;
      /* identical to box height, or 100% */
      color: #ffffff;
      opacity: 0.87;
    }
  }
}
.alarm {
  padding: 16px;
}
.alarms {
  color: #e07073;
  font-size: 14px;
  line-height: 20px;
}
.alarm-left {
}
.alarm-date {
}
.alarm-laber {
  color: rgba(255, 255, 255, 0.87);
  font-size: 12px;
  opacity: 0.6;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
  margin-bottom: 8px;
}
.bump4 {
  color: #dc5357 !important;
}
.bump3 {
  color: #dea15f !important;
}
.bump2 {
  color: #edd977 !important;
}
.alarm-h {
  font-size: 24px;
  line-height: 24px;
  /* identical to box height, or 100% */
  text-align: center;
  font-weight: bold;
  color: #ffffff;
  opacity: 0.87;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
}
.alarm-h.active {
  color: #8ebf86;
}
.alarm-pp {
  color: #8ebf86 !important;
}
.alarm-p {
  font-size: 16px;
  line-height: 16px;
  /* identical to box height, or 100% */
  text-align: center;
  color: #ffffff;
  opacity: 0.6;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
}
.alarm-right {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .alarm-date {
    margin-left: 44px;
  }
}
.alarm-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}
.alarm-bottom {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.alarm {
  .alarm-ul {
    margin-top: 16px;
    height: 86vh;
    overflow: auto;
    .alarm-li.active {
      background: linear-gradient(
          0deg,
          rgba(255, 255, 255, 0.1),
          rgba(255, 255, 255, 0.1)
        ),
        #393f52;
      .alarm-h {
        color: rgba(255, 255, 255, 0.87);
        text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
      }
      .alarm-time .time-li span {
        color: rgba(255, 255, 255, 0.87);
      }
    }
    .alarm-li.active2 {
      opacity: 0.5;
    }
    .alarm-li {
      background: #393f52;
      box-shadow: 0px 8px 24px rgba(18, 21, 30, 0.09);
      border-radius: 8px;
      padding: 16px 24px;
      margin-bottom: 16px;
      cursor: pointer;
    }
    .alarm-li:last-child {
      margin: 0;
    }
  }
  .alarm-tab {
    display: flex;
    .alarm-tab-li {
      color: #72788c;
      border: 0.5px solid #72788c;
      border-radius: 4px;
      margin-right: 16px;
      padding: 0 12px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .alarm-tab-li.active {
      background: #1556d7;
      border: 0.5px solid #1556d7;
      color: #fff;
    }
  }
}
.modal-top {
  height: 72px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  justify-content: space-between;
  border-bottom: 1px solid #0f1526;
  .modal-head {
    font-size: 24px;
  }
  .modal-close {
    cursor: pointer;
    img {
      width: 20px;
      display: block;
    }
  }
}
.Airroute-time {
  padding-top: 55px;
}
.bumpprevention-page {
  background: #1c1f24;
  overflow: hidden;
  height: 100%;
  color: #fff;
  .time-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 4px;
    margin-bottom: 4px;
    margin-left: 45px;
    .time {
      color: rgba(255, 255, 255, 0.6);
      font-size: 12px;
    }
  }
  .Deliverfood {
    position: absolute;
    background: rgba(153, 117, 255, 0.1);
    border-width: 0px 1px;
    border-style: solid;
    border-color: #907acc;
    height: calc(100vh - 154px);
    bottom: 24px;
    z-index: 9;
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 12px;
    }
  }
  .grey {
    position: absolute;
    background: rgba(15, 21, 38, 0.7);
    height: 934px;
    bottom: 0;
    border-right: 1px solid #596f88;
  }
  .Airroute-null {
    height: 34px;
    width: 100%;
  }
  .Airroute-head {
    display: flex;
    align-items: center;
    height: 32px;
    background: #0f1526;
    box-shadow: inset 0px -8px 16px rgba(0, 0, 0, 0.12),
      inset 0px 12px 12px rgba(255, 255, 255, 0.12),
      inset 0px 1px 2px rgba(255, 255, 255, 0.1);
    .head-left {
      height: 100%;
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgba(255, 255, 255, 0.87);
      font-size: 12px;
    }
    .head-right {
      width: 550px;
      height: 100%;
      padding: 10px 0;
      position: relative;
      box-sizing: border-box;
    }
    // .head-line{
    //   height: 12px;
    //   width: 20%;
    // }
    .rainstorm-box {
      position: absolute;
      height: 100%;
      background: rgba(107, 178, 161, 0.4);
      mix-blend-mode: normal;
      /* 雷雨/边 */
      border-width: 0px 0.5px;
      border-style: solid;
      border-color: #7accb8;
      transform: matrix(-1, 0, 0, 1, 0, 0);
      top: 0;
      width: 10%;
      left: 20%;
      img {
        width: 22px;
        right: -11px;
        top: -1.5px;
        position: absolute;
      }
    }
  }
  .Airroute-ul {
    position: relative;
    height: calc(100% - 172px);
    overflow: scroll;
  }
  .Airroute-li:nth-child(2n) .flight-ul {
    background: #2d3548;
  }
  .Airroute-li:hover {
    .flight-left {
      background: #1556d7;
    }
    .flight-ul {
      background: #1f3458;
    }
  }
  .Airroute-li:first-child .flight-ul {
    border-width: 2px 0px 0px 0;
    border-style: solid;
    border-color: #3b455a;
  }
  .Airroute-li:last-child .flight-ul {
    border-width: 0px 0px 2px 0;
    border-style: solid;
    border-color: #3b455a;
  }
  .Airroute-li {
    display: flex;
    height: 22px;
    .flight-left {
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgba(255, 255, 255, 0.87);
      font-size: 12px;
    }
    .flight-ul {
      height: 100%;
      padding: 6px 0;
      box-sizing: border-box;
      border-width: 1px 0px 1px 0;
      border-style: solid;
      border-color: #3b455a;
      align-items: center;
    }
  }
  .bump-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    right: 0;
    height: 72px;
    padding: 0 24px;
    top: 24px;
    width: 1675px;
    padding-left: 344px;
    box-sizing: border-box;
    .bump-ul {
      display: flex;
      align-items: center;
      .bump-left {
        text-align: left;
      }
      .bump-right {
        text-align: right;
      }
      .bump-center {
        display: flex;
        align-items: center;
        height: 24px;
        border-left: 1px solid rgba(255, 255, 255, 0.3);
        border-right: 1px solid rgba(255, 255, 255, 0.3);
        padding: 0 80px;
        margin: 0 80px;
        .bump-p {
          margin-top: 0;
          margin-bottom: 2px;
        }
      }
      .bump-number {
        color: rgba(255, 255, 255, 0.87);
        font-size: 32px;
        text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
      }
      .bump-li {
        margin-left: 80px;
      }
      .bump-h {
        color: rgba(255, 255, 255, 0.87);
        font-size: 16px;
        text-align: center;
      }
      .bump-p {
        color: rgba(255, 255, 255, 0.6);
        font-size: 12px;
        margin-top: 4px;
      }
    }
    .bump-bt {
      background: #164b9a;
      border-radius: 4px;
      color: rgba(255, 255, 255, 0.87);
      padding: 0 20px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img {
        width: 16px;
        margin-right: 2px;
      }
    }
  }
  .more-page {
    position: absolute;
    right: 0px;
    padding: 12px;
    bottom: 48px;
    z-index: 999;
  }
  .more-box {
    background: #393f52;
    border-radius: 4px;
    width: 308px;
    text-align: left;
    overflow: hidden;
    .more-head {
      color: #fff;
      opacity: 0.87;
      line-height: 36px;
      padding: 0 12px;
      font-size: 12px;
    }
    .label-li {
      width: 100%;
      box-sizing: border-box;
      border-radius: 0 !important;
    }
    .label-li:hover {
      background: #50566a;
    }
    .label-li.active {
      background: #50566a;
    }
  }
  .label-li:hover {
    background: #393f52;
    border-radius: 8px 8px 0px 0px;
    .label-li-left {
      color: rgba(255, 255, 255, 1);
    }
  }
  .label-li.active {
    background: #393f52;
    border-radius: 8px 8px 0px 0px;
    .label-li-left {
      color: rgba(255, 255, 255, 1);
    }
  }
  .label-li {
    width: 25%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    padding-left: 36px;
    position: relative;
    .situation {
      position: absolute;
      width: 16px;
      left: 12px;
      top: 15px;
    }
    .label-li-left {
      display: flex;
      align-items: center;
      color: rgba(255, 255, 255, 0.7);
      font-size: 16px;
      cursor: pointer;
    }
    .label-li-right {
      cursor: pointer;
      img {
        width: 14px;
        display: block;
      }
    }
  }
  .label-box {
    position: absolute;
    left: 0;
    bottom: 1px;
    width: 100%;
    background: #262d40;
    height: 48px;
    display: flex;
    align-items: center;
    .label-ul {
      display: flex;
      flex: 1;
    }
    .more {
      width: 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-left: 1px solid #000;
      font-weight: bold;
      font-size: 16px;
      position: relative;
      height: 100%;
    }
    .more:hover {
      background: #393f52;
    }
  }
  .bump-head {
    font-size: 32px;
    padding: 0 30px;
    position: absolute;
    left: 0;
    display: flex;
    line-height: 32px;
    top: 32px;
  }
  .bumpprevention-top {
    background: url("~@/assets/images/index/head.png") no-repeat #303444;
    background-size: 100% 100%;
    height: 96px;
    width: 100%;
    z-index: 3;
    position: relative;
  }
  .bumpprevention-box {
    display: flex;
    background: #1c1f24;
    height: calc(100vh - 96px);
  }
  .bumpprevention-right {
    overflow: hidden;
    background: #262d40;
    z-index: 3;
    position: relative;
  }
  .bumpprevention-left {
    flex: 1;
    position: relative;
    .operation-modal {
      position: absolute;
      top: 15px;
      right: 15px;
      z-index: 999;
      .modal-li {
        background: #210e0e;
        border: 0.5px solid rgba(224, 112, 115, 0.5);
        box-shadow: inset 0px 0px 12px rgba(224, 112, 115, 0.3);
        border-radius: 4px;
        padding: 12px;
        width: 260px;
        text-align: left;
        margin-bottom: 16px;
        .modal-li-h {
          color: #e07073;
          font-size: 16px;
          margin-bottom: 12px;
        }
        .modal-li-p {
          color: rgba(255, 255, 255, 0.6);
          font-size: 14px;
          span {
            color: #fff;
            margin: 0 5px;
          }
        }
        .modal-li-a {
          cursor: pointer;
          color: rgba(255, 255, 255, 0.6);
          font-size: 12px;
          margin-top: 25px;
        }
      }
    }
    .operation-bottom {
      position: absolute;
      width: 85px;
      left: 0;
      bottom: 72px;
      z-index: 9;
      .operation-a {
        margin-top: 32px;
        cursor: pointer;
        opacity: 0.87;
        img {
          width: 21px;
        }
        p {
          font-size: 12px;
          margin: 0;
          margin-top: 8px;
        }
      }
      .operation-a:hover {
        opacity: 1;
      }
    }
    .operation-ul {
      margin-bottom: 20px;
      border-radius: 8px;
      overflow: hidden;
      .operation-li:first-child {
        border-bottom: 1px solid #252933;
      }
      .operation-li {
        margin: 0;
        border-radius: 0;
      }
    }
    .operation-li:hover {
      opacity: 1;
    }
    .operation-li {
      background: #393f52;
      opacity: 0.87;
      border-radius: 8px;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      cursor: pointer;
      img {
        width: 23.14px;
        display: block;
      }
    }
    .operation-top {
      position: absolute;
      left: 24px;
      top: 24px;
      z-index: 9;
    }
    .alarmprompt-box{
      position: absolute;
      left: 246px;
      top: 24px;
      display: flex;
      align-items: center;
      z-index: 9;
      .alarmprompt-line{
        font-size: 16px;
        color: rgba(255, 255, 255, 0.6);
        margin: 0 16px;
      }
      .alarmprompt{
        display: flex;
        align-items: center;
        background: #262D40;
        border-radius: 4px;
        padding:  8px 8px 8px 16px;
        .alarmprompt-laber{
          margin-right: 16px;
          color: rgba(255, 255, 255, 0.7);
          font-size: 16px;
        }
        .alarmprompt-img{
          display: flex;
          align-items: center;
          position: relative;
          .alarmprompt-text{
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            cursor: pointer;
            .alarmprompt-p{
              color: #EBA967;
              font-size: 16px;
              margin-left: 10px;
              span{
                margin-left: 24px;
              }
            }
            .alarmprompt-p.active{
              color: #E07073;
              margin-right: 10px;
              margin-left: 0;
            }
          }
          img{
            width: 134px;
            height: 36px;
            display: block;
          }
          img:last-child{
            margin-left: -8px;
          }
        }
      }
    }
    .operation-img {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/bumpprevention/bumpprevention.vue